import { Component, OnInit } from '@angular/core';
import { NavController, ToastController, ModalController, AlertController } from '@ionic/angular';
import { FormGroup, FormBuilder } from '@angular/forms';
import { UtilService } from '../../../../service/util.service';
import { Storage } from '@ionic/storage';
import { UserProfile } from '../../../../models/user-profile.model';
import { ReportService } from '../../report.service';
import { PosService } from '../../../pos/pos.service';


declare var IminPrinter: any;
declare var require: any;
const html2canvas = require('html2canvas');
@Component({
  selector: 'app-report-reprint-struck',
  templateUrl: './report-reprint-struck.page.html',
  styleUrls: ['./report-reprint-struck.page.scss'],
})
export class ReportReprintStruckPage implements OnInit {

  monthList: any[] = ['JAN', 'FEB', 'MAR', 'APR', 'MEI', 'JUN', 'JUL', 'AGU', 'SEP', 'OKT', 'NOV', 'DES'];
  timezone: any[] = ['Asia/Jakarta', 'Asia/Makassar', 'Asia/Jayapura'];

  formReprintReceipt: FormGroup;
  token: string;
  userProfile: UserProfile = new UserProfile();
  printers: string[];
  isDefaultPrinterSelected = false;
  selectedPrinter: any;

  productSales: any[] = [];
  salesData: any;
  salesDetailIsiHampers:any;
  pointMutationData: any[] = [];
  customerData: any;
  receiptNo: any;
  transDate: any;
  transTime: any;
  cashierName: string = '';
  totalPaymentWithoutPromo: number = 0;
  totalPayment: number = 0;
  totalItem: number = 0;
  voucherValue: number = 0;
  paymentVoucher: number = 0;
  paymentVoucherCode: string = '';
  pointMutationType: any = '';
  customerCredit: number = 0;
  customerDebit: number = 0;
  memberPhone: any = '';
  memberName:any='';
  totalPointAdd: number = 0;
  memberPointValueUsed: number = 0;
  memberPointValue: number = 0;
  memberPointUsed: number = 0;
  totalChange: number = 0;
  totalCustomerCash: number = 0;
  firstAddress: any;
  lastAddress: any;
  counterPhone: any;
  transactionType: any;
  customerTransfer: number = 0;
  resellerName: any = '';
  resellerCode: any = '';
  transactionDiscount : number =0;
  receiptName:any='';
  referralCode:any='';
  earlyPoint: number = 0;
  inPoint: number = 0;
  outPoint: number = 0;
  endPoint: number = 0;
  voucherCode:any='';
  expiringPoin:any[]= [];
  customerItem:any[]=[];
  showReferralCodeInStruck:boolean=false;
  printerImin: any;
  deviceType:any='';
  stickerNumber:any='';
  companyCode:any='';
  companyName:any='';
  companyAddress:any='';
  companyNpwp:any='';
  constructor(
    private fb: FormBuilder,
    private navCtrl: NavController,
    private toastCtrl: ToastController,
    private utilService: UtilService,
    private modalController: ModalController,
    private storage: Storage,
    private alertController: AlertController,
    private reportService: ReportService,
    private posService:PosService
  ) { }

  ngOnInit() {
    this.buildFormReprintReceipt();

    Promise.all([
      this.storage.get('user_token'),
      this.storage.get('user_profile')
    ])
    .then(([token, profile]) => {
      if(token) {
        this.token = token;
        this.userProfile = new UserProfile(profile);
      }
      const ua = navigator.userAgent;
      if (/Mobile|Android|iPhone|iPad|Tablet/i.test(ua)) {
      //alert("Akses dari tablet / mobile");
        this.deviceType = 'tab';
        this.printerImin = new IminPrinter("127.0.0.1");
          try {
              this.printerImin.connect().then(() => {
                console.log("Connected");
              });
            } catch (err) {
              console.error(err);
            }
      } else {
            // WebSocket settings
          JSPM.JSPrintManager.auto_reconnect = true;
          JSPM.JSPrintManager.start();
          JSPM.JSPrintManager.WS.onStatusChanged = () => {
          if (this.jspmWSStatus()) {
            // get client installed printers
            JSPM.JSPrintManager.getPrinters().then((myPrinters: string[]) => {
              this.printers = myPrinters;
              this.isDefaultPrinterSelected = true;
              });
            }
          };
      }
    });
  }

  jspmWSStatus() { // Check JSPM WebSocket status
    if (JSPM.JSPrintManager.websocket_status === JSPM.WSStatus.Open) {
        return true;
    } else if (JSPM.JSPrintManager.websocket_status === JSPM.WSStatus.Closed) {
        alert('JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm');
        return false;
    } else if (JSPM.JSPrintManager.websocket_status === JSPM.WSStatus.Blocked) {
        alert('JSPM has blocked this website!');
        return false;
    }
  }

  buildFormReprintReceipt() {
    this.formReprintReceipt = this.fb.group({
      receiptNo: [null]
    });
  }
  getReceiptS(){
  const printContent = `
    <html>
      <head>
        <style>
          body { font-family: monospace; white-space: pre; }
          .bold { font-weight: bold; }
        </style>
      </head>
      <body>
        <div class="bold">Hello from Ionic PWA!</div>
        <div>Thank you for your purchase!</div>
        <div>--------------------</div>
        <div>Item 1: $10</div>
        <div>Item 2: $15</div>
        <div>Total: $25</div>
      </body>
    </html>
  `;

  const newWindow = window.open('', '', 'width=300,height=600');
  newWindow.document.write(printContent);
  newWindow.document.close();
  newWindow.print();

  }
  getReceipt(action:any) {
    const previewArea = document.getElementById('previewArea');
    previewArea.innerText = '';
    previewArea.style.display = 'none';
    const previewAreaImin = document.getElementById('previewAreaImin');
    previewAreaImin.innerText = '';
    previewAreaImin.style.display = 'none';
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      const formReprintReceipt = this.formReprintReceipt.value;
      this.reportService.getSalesByReceiptNumber({ "token": this.token }, formReprintReceipt.receiptNo)
      .subscribe((response) => {
        this.utilService.loadingDismiss();
        this.voucherCode='';
        this.memberName = '';
        this.memberPhone ='';
        this.referralCode ='';
        this.companyCode = '';
        this.companyName='';
        this.companyAddress='';
        this.companyNpwp='';
        if (response.status.code == 200) {
          let company = response.results.company;
          if(company){
            this.companyCode = company.company_code;
            this.companyName = company.company_name;
            this.companyAddress = company.address;
            this.companyNpwp = company.npwp;
          }
          this.productSales = response.results.product_sales;
          this.salesData = response.results.sales_data;
          this.pointMutationData = response.results.point_mutation_data;
          this.earlyPoint = Number(response.results.early_point);
          this.inPoint = Number(response.results.in_point);
          this.outPoint = Number(response.results.out_point);
          this.endPoint = this.earlyPoint+this.inPoint-this.outPoint;
          this.customerData = response.results.customer_data;
          this.firstAddress = this.salesData.first_address;
          this.lastAddress = this.salesData.last_address;
          this.counterPhone = this.salesData.phone;
          this.receiptNo = this.salesData.receipt_no;
          this.transDate = this.salesData.trans_date;
          this.transTime = this.salesData.trans_time;
          this.cashierName = this.salesData.name_user;
          this.totalCustomerCash = this.salesData.cash;
          this.totalChange = this.salesData.change;
          this.customerDebit = this.salesData.debit_card;
          this.customerCredit = this.salesData.credit_card;
          this.expiringPoin = response.results.expiring_points;
          this.voucherValue = this.salesData.voucher;
          this.paymentVoucher = this.salesData.payment_voucher ?parseInt(this.salesData.payment_voucher):0;
          this.paymentVoucherCode = this.salesData.payment_voucher_code;
          let voucherData = response.results.voucher_data;
          this.customerItem = response.results.customer_item;
          this.receiptName= response.results?response.results.receipt_name:'';
          this.stickerNumber = response.results?response.results.sales_data.sticker_number:'';
          this.salesDetailIsiHampers = response.results.salesDetailIsiHampers;
          if(voucherData.length>0){
            for(let i=0;i<voucherData.length;i++){
              this.voucherCode += voucherData[i].voucher_code;
            }
          }
          this.transactionType = this.salesData.transaction_type;
          this.customerTransfer = this.salesData.transfer;
          this.transactionDiscount = this.salesData.discount;
          if(this.customerData){
            this.memberName = this.customerData.customer_name;
            this.memberPhone = this.customerData.phone;
            this.referralCode = this.customerData.referral_code;
          }
          if(this.pointMutationData.length > 0) {
            for(let x = 0; x < this.pointMutationData.length; x++) {
              if(this.pointMutationData[x].point_mutation_type_id === 'O') {
                this.memberPointValue = parseInt(this.pointMutationData[x].point) * 100;
                this.memberPointUsed = this.pointMutationData[x].point;
              }
              if(this.pointMutationData[x].point_mutation_type_id === 'I') {
                this.totalPointAdd = this.pointMutationData[x].point;
              }
            }
          }

          this.showReferralCodeInStruck=response.results.show_referral_code;
          if(this.customerData !== null) {
            this.resellerName = this.customerData.customer_name;
            this.resellerCode = this.customerData.referral_code;
          }
          this.calcTotal();
          if(action=='preview'){
            this.printReceipt(action);
          }          
          else if(action=='imin'){
            this.cetak(action);
          }
          else{
            if(this.deviceType =='tab'){
              if(this.userProfile.counter_detail.printer_type=='imin_external'){
                this.cetak(action);
              }
              else if(this.userProfile.counter_detail.printer_type=='imin_internal'){
                this.cetak(action);
              }
            }
            else{
              if(this.userProfile.counter_detail.printer_type=='thermal'){
                let print_amount=1;
                let last_receipt =false;
                for(let i=0;i<print_amount;i++){
                  if(i==print_amount-1){
                    last_receipt=true;
                  }
                  this.printReceiptThermal(last_receipt);
                }
              }
              else{
                this.printReceipt(action);
              }
            }
          }
        }
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal mendapatkan data Sales!' }).then(t => t.present());
      });
    });
  }

  printReceipt(action:any) {
    const previewArea = document.getElementById('previewArea');
    if(action=='preview'){
      if (previewArea) {
        previewArea.innerText = this.generateReceiptDetail();
        previewArea.style.display = 'block';
      }
    }
    else{
      var dT = new Date(this.transDate+' '+this.transTime);
      let transactionDate = dT;
      let timezoneName = this.userProfile.counter_detail ? this.timezone[parseInt(this.userProfile.counter_detail.timezone)] : this.timezone[0];
      let convertTime = this.utilService.convertDateWithMoment(dT, timezoneName);
      let convertDate = this.utilService.convertDate(transactionDate);

      let monthName: any = this.monthList[(parseInt(convertDate.months)-1)];
      let transDate = convertDate.dates + '-' + monthName + '-' + convertDate.years;
      let transTime = convertTime.hours + ':' + convertTime.minutes + ':' + convertTime.seconds;

      let totalPromo: number = 0;
      let andaHemat :number=0;

      //Create a ClientPrintJob
      const cpj = new JSPM.ClientPrintJob();

      //Set Printer type (Refer to the help, there many of them!)
      if ( this.isDefaultPrinterSelected ) {
        cpj.clientPrinter = new JSPM.DefaultPrinter();
      } else {
        cpj.clientPrinter = new JSPM.InstalledPrinter(this.selectedPrinter);
      }

      //Set content to print...
      //Create ESP/POS commands for sample label
      let esc = '\x1B'; //ESC byte in hex notation
      let newLine = '\x0A'; //LF byte in hex notation
      let cut = "\x1b" + "\x69";
      let cmds = esc + "@"; //Initializes the printer (ESC @)
      cmds += esc + '!' + '\x00'; //Character font A selected (ESC ! 0)
      cmds += esc + '*' + '\x32'; //Character font A selected (ESC ! 0)
      cmds += '---------------------------------';
      cmds += 'NO STRUK : ' + this.receiptNo;
      cmds += newLine;
      cmds += 'TANGGAL  : ' + transDate + ' ' + transTime;
      cmds += newLine;
      cmds += 'KASIR    : ' + this.cashierName.toUpperCase();
      cmds += newLine;
      if(this.stickerNumber!='' && this.stickerNumber !== null){
        cmds += 'NAMA BA  : ' + this.stickerNumber.toUpperCase();
        cmds += newLine;
      }
      cmds += '---------------------------------';
      cmds += esc + '!' + '\x00'; //Character font A selected (ESC ! 0)
      //Start List Barang Belanja
      let totalDiskonFreeItem = 0;
      for(let i = 0; i < this.productSales.length; i++) {
        let sales_transaction_detail_id: any = parseInt(this.productSales[i].sales_transaction_detail_id);
        if(this.productSales[i].typePromo !== 'FREE ITEM (ITEM)' && this.productSales[i].typePromo !== 'FREE ITEM (NOMINAL)') {
          let priceProduct: number = parseInt(this.productSales[i].price);
          let qtyBuy: number = parseInt(this.productSales[i].qty);
          let nettProduct: number = priceProduct * qtyBuy;
          let qtyFree: number = parseInt(this.productSales[i].qtyFree);
          let nettFree: number = priceProduct * qtyFree;
          if(this.productSales[i].qtyFree > 0) {
            if(qtyBuy>0){
              let lblPriceXQty: String = qtyBuy + ' x ' + this.formatRupiah(priceProduct.toString());
              let lblNettProduct: String = this.getLblNett(this.formatRupiah(nettProduct.toString()), lblPriceXQty.length);
              cmds += this.productSales[i].initialName;
              cmds += newLine;
              cmds += lblPriceXQty.toString() + lblNettProduct.toString();
              cmds += newLine;
            }
            /*let lblPriceXQtyFree: String = 'FREE ' + qtyFree + ' x ' + this.formatRupiah(priceProduct.toString());
            let lblNettFree: String = this.getLblNett('('+this.formatRupiah(nettFree.toString())+')', lblPriceXQtyFree.length);
            cmds += this.productSales[i].initialName;
            cmds += newLine;
            cmds += lblPriceXQtyFree.toString() + lblNettFree.toString();
            cmds += newLine;*/
            totalDiskonFreeItem+=nettFree;
          } else {
            let lblPriceXQty: String = qtyBuy + ' x ' + this.formatRupiah(priceProduct.toString());
            let lblNettProduct: String = this.getLblNett(this.formatRupiah(nettProduct.toString()), lblPriceXQty.length);
            cmds += this.productSales[i].initialName;
            cmds += newLine;
            cmds += lblPriceXQty.toString() + lblNettProduct.toString();
            cmds += newLine;
          }
          
          if(this.salesDetailIsiHampers.length>0){
            let isi = this.salesDetailIsiHampers.filter(x=>x.sales_transaction_detail_id==sales_transaction_detail_id);
            if(isi.length>0){
              for(let ih=0;ih<isi.length;ih++){
                let qty_isi = parseInt(isi[ih].qty);
                let lblIsiHamper = this.getLblIsiHamper(isi[ih].product_name,qty_isi,1)
                cmds += lblIsiHamper;
                cmds += newLine;
              }
            }
          }
        }

        if(this.productSales[i].typePromo === 'FREE ITEM (ITEM)' || this.productSales[i].typePromo === 'FREE ITEM (NOMINAL)') {
          let price: number = parseInt(this.productSales[i].priceAfterPromo);
          let qty: number = parseInt(this.productSales[i].qtyFree);
          let nett: number = price * qty;
          /*let lblPriceAndQty: String = 'FREE ' + qty + ' x ' + this.formatRupiah(price.toString());
          let lblNett: String = this.getLblNett('('+this.formatRupiah(nett.toString())+')', lblPriceAndQty.length);
          cmds += this.productSales[i].initialName;
          cmds += newLine;
          cmds += lblPriceAndQty.toString() + lblNett.toString();
          cmds += newLine;*/
          totalDiskonFreeItem+=nett;
        }
      }
      //End List Barang Belanja
       //Start Detail Promo Product
      for(let i = 0; i < this.productSales.length; i++) {
        if(this.productSales[i].typePromo !== 'FREE ITEM (ITEM)' && this.productSales[i].typePromo !== 'FREE ITEM (NOMINAL)') {
          if(this.productSales[i].typePromo === 'NOMINAL' || this.productSales[i].typePromo === 'PERSENTASE') {
            let countPromoDiff: number = this.productSales[i].discNonRedeem;//(this.productSales[i].price * this.productSales[i].qty) - (this.productSales[i].priceAfterPromo * this.productSales[i].qty);
            totalPromo = totalPromo + countPromoDiff;
            /*let strCountPromoDiff: string = '(' + this.formatRupiah(countPromoDiff.toString()) + ')';
            let lblCountPromo: String = this.getLabelPrintNominal(strCountPromoDiff);

            cmds += this.productSales[i].initialName;
            cmds += newLine;
            cmds += '            DISKON : ' + lblCountPromo;
            cmds += newLine;*/
          } else {
            if(this.productSales[i].valPromoNominal !== 0 || this.productSales[i].valPromoPercentage !== 0) {
              let countPromo: number =this.productSales[i].discNonRedeem;// ((this.productSales[i].price * this.productSales[i].qty) * (this.productSales[i].valPromoPercentage / 100)) + this.productSales[i].valPromoNominal;
              totalPromo = totalPromo + countPromo;
              /*let strCountPromoDiff: string = '(' + this.formatRupiah(countPromo.toString()) + ')';
              let lblCountPromo: String = this.getLabelPrintNominal(strCountPromoDiff);

              cmds += this.productSales[i].initialName;
              cmds += newLine;
              cmds += '            DISKON : ' + lblCountPromo;
              cmds += newLine;*/
            }
          }
        }
        
        if(this.productSales[i].qtyFree>0 ) {
          andaHemat+= (this.productSales[i].price * this.productSales[i].qtyFree);
        }
        if(Number(this.productSales[i].price)==1 && Number(this.productSales[i].qtyFree)==0){
         // andaHemat+= (Number(this.productSales[i].price) * Number(this.productSales[i].qty));
        }
      }
      
      andaHemat+=totalPromo;
      cmds += '---------------------------------';
      

      //Start Voucher (member or general)
      if(this.voucherValue !== 0) {
        /*let lblVoucherValue: String = this.getLabelPrintNominal(this.formatRupiah(this.voucherValue.toString()));
        cmds += '   VOUCHER POTONGAN: ' + lblVoucherValue;
        cmds += newLine;*/
        andaHemat+=this.voucherValue;
      }
      //End Voucher

      let lblTotalPromo: String = this.getLabelPrintNominal(this.formatRupiah(andaHemat.toString()));
      cmds += '        TOTAL DISKON : ' + lblTotalPromo;
      cmds += newLine;
      let hargaJual = totalDiskonFreeItem + this.totalPaymentWithoutPromo;
      let lblPaymentWithoutPromo: String = this.getLabelPrintNominal(this.formatRupiah(hargaJual.toString()));
      cmds += '        HARGA JUAL   : ' + lblPaymentWithoutPromo;
      cmds += newLine;
     
      //End Detail Promo Product
      let totalItemPrice = this.totalPaymentWithoutPromo-totalPromo-this.voucherValue;
      cmds += '---------------------------------';
      let lblTotalPayment: String = this.getLabelPrintNominal(this.formatRupiah(totalItemPrice.toString()));
      let lblTotalItem: String = this.getLabelTotalItem(this.totalItem);
      cmds += '' + lblTotalItem + lblTotalPayment;
      cmds += newLine;
      let lblTotalCustomerCash: String = this.getLabelPrintNominal(this.formatRupiah(this.totalCustomerCash.toString()));
      cmds += '             TUNAI : ' + lblTotalCustomerCash;
      cmds += newLine;

      //Start transfer
      if(this.customerTransfer !== 0) {
        let lblCustomerTransfer: String = this.getLabelPrintNominal(this.formatRupiah(this.customerTransfer.toString()));
        cmds += '          TRANSFER : ' + lblCustomerTransfer;
        cmds += newLine;
      }

      //Start Penggunaan Point
      if(this.salesData.member_point!=0) {
        let lblPointValue: String = this.getLabelPrintNominal(this.formatRupiah(this.salesData.member_point.toString()));
        cmds += '          POINT RP : ' + lblPointValue;
        cmds += newLine
      }
      //End Penggunaan Point
      //Start Payment Voucher
      if(this.paymentVoucher !== 0) {
        let lblVoucherValue: String = this.getLabelPrintNominal(this.formatRupiah(this.paymentVoucher.toString()));
        cmds += 'VOUCHER PEMBAYARAN : ' + lblVoucherValue;
        cmds += newLine;
      }
      //End  Payment Voucher

      //Start Pembayaran Non Tunai
      if(this.customerCredit !== 0 && this.customerCredit !== null) {
        let lblCustomerCredit: String = this.getLabelPrintNominal(this.formatRupiah(this.customerCredit.toString()));
        cmds += '            KREDIT : ' + lblCustomerCredit;
        cmds += newLine;
      }
      if(this.customerDebit !== 0 && this.customerDebit !== null) {
        let lblCustomerDebit: String = this.getLabelPrintNominal(this.formatRupiah(this.customerDebit.toString()));
        cmds += '             DEBIT : ' + lblCustomerDebit;
        cmds += newLine;
      }
      //End Pembayaran Non Tunai

      let lblTotalChange: String = this.getLabelPrintNominal(this.formatRupiah(this.totalChange.toString()));
      cmds += '        KEMBALI RP : ' + lblTotalChange;
      cmds += newLine;
      let finalPayment =totalItemPrice;
      let dpp =Math.round((finalPayment/1.11) *(11/12));
      let lblDpp: String = this.getLabelPrintNominal(this.formatRupiah(dpp.toString()));
      cmds += '               DPP : ' + lblDpp;
      cmds += newLine;
      let ppn = Math.round(dpp * (12/100));
      let lblTotalPpn: String = this.getLabelPrintNominal(this.formatRupiah(ppn.toString()));
      cmds += '               PPN : ' + lblTotalPpn;
      cmds += newLine;
      cmds += '---------------------------------';
      
      if(this.paymentVoucherCode !== '' && this.paymentVoucherCode!=null) {
        cmds += newLine;
        cmds += 'KODE VOUCHER PEMBAYARAN    : ';
        cmds += newLine;
        cmds += this.paymentVoucherCode;
        cmds += newLine;
        cmds += '---------------------------------';
      }
      if(this.voucherCode !== '' && this.voucherCode !== null) {
        cmds += newLine;
        cmds += 'KODE VOUCHER POTONGAN    : ';
        cmds += newLine;
        cmds += this.voucherCode;
        cmds += newLine;
        cmds += '---------------------------------';
      }
      
      if(this.memberPhone !== '') {
        if(this.memberName!='' && this.memberName!=null){
          cmds += newLine;
          cmds += 'NAMA MEMBER: ' + this.memberName;
        }
        cmds += newLine;
        cmds += 'PHONE : ' + this.memberPhone;
        if(this.showReferralCodeInStruck==true){
          cmds += newLine;
          cmds += 'REFERRAL CODE : ' + this.referralCode;
        }
        let totalLength=14;
        let lblEarrlyPoint: String = this.getLabelPrintPoint(this.formatRupiah(this.earlyPoint.toString()),totalLength);
        let lblInPoint: String = this.getLabelPrintPoint(this.formatRupiah(this.inPoint.toString()),totalLength);
        let lblOutPoint: String = this.getLabelPrintPoint(this.formatRupiah(this.outPoint.toString()),totalLength);
        let lblEndPoint: String = this.getLabelPrintPoint(this.formatRupiah(this.endPoint.toString()),totalLength);
        if(this.endPoint>0){
          cmds += newLine;
          cmds += 'POIN AWAL       : ' + lblEarrlyPoint;
          cmds += newLine;
          cmds += 'POIN DIDAPATKAN : ' + lblInPoint;
          cmds += newLine;
          cmds += 'POIN DIPAKAI    : ' + lblOutPoint;
          cmds += newLine;
          cmds += 'POIN AKHIR      : ' + lblEndPoint;
        }
        if(this.expiringPoin.length>0){
          let namaBulan = [
            'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
            'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'
          ];
          cmds += newLine;
          cmds += 'POIN YANG AKAN EXPIRED ';
          cmds += newLine;
          cmds += 'TGL EXP           | JUMLAH POIN ';
          cmds += newLine;
          for(let ep=0;ep<this.expiringPoin.length;ep++){
            let convertEpDate = this.utilService.convertDate(this.expiringPoin[ep].expired_date);
            let bulanEpIndex = Number(convertEpDate.months) -1 ;
            this.expiringPoin[ep].ep_date = convertEpDate.dates + ' ' + namaBulan[bulanEpIndex] + ' ' + convertEpDate.years;
            let lblexpPoint: String = this.getLabelPrintPoint(this.formatRupiah(this.expiringPoin[ep].point_remains.toString()),13);
            let lblepDate: String = this.getLabelPrintPoint(this.expiringPoin[ep].ep_date.toString(),17);
            cmds += newLine;
            cmds += lblepDate + ' | '+lblexpPoint ;
          }
        }
        cmds += newLine;
        cmds += '---------------------------------';
        if(this.customerItem.length>0){
          cmds += newLine;
          cmds += 'BARANG DIBAWA PELANGGAN';
          for(let i=0;i<this.customerItem.length;i++){
            cmds+=newLine;
            cmds += this.customerItem[i].item_name + ' : '+this.customerItem[i].item_qty;
          }
          cmds+=newLine;
          cmds += '---------------------------------';
        }
      }
      //End detail Member Point

      cmds += newLine;
      cmds += newLine;
      cmds += ' BARANG YANG SUDAH DIBELI TIDAK ';
      cmds += newLine;
      cmds += ' DAPAT DITUKAR ATAU DIKEMBALIKAN ';
      cmds += newLine;
      /*cmds += newLine;
      cmds += ' JIKA MEMILIKI PERTANYAAN, SARAN,';
      cmds += newLine;
      cmds += '    ATAU KRITIK, HUBUNGI KAMI ';
      cmds += newLine;
      cmds += '     DI 081138911248 ATAU ';
      cmds += newLine;
      cmds += ' EMAIL: CS@SECRETGARDEN.CO.ID ';
      cmds += newLine;*/
      cmds += '           TERIMA KASIH';
      cmds += newLine;
      cmds += newLine;
      cmds += newLine;
      cmds += this.getLabelHeaderReceipt(String(this.companyName));
      cmds += newLine;
      if(this.receiptName!=''){
        cmds += this.getLabelHeaderReceipt(String(this.receiptName));
        cmds += newLine;
      }
      cmds += this.getLabelHeaderReceipt(String(this.userProfile.counter_detail.counter_name));
      cmds += newLine;
      if(this.companyNpwp!=''){
        cmds += this.getLabelHeaderReceipt("NPWP : " +String(this.companyNpwp));
        cmds += newLine;
      }
      cmds += this.getLabelHeaderReceipt(String(this.companyAddress));
      cmds += newLine;
      if(this.userProfile.counter_detail.phone !== null && this.userProfile.counter_detail.phone !== '') {
        cmds += this.getLabelHeaderReceipt(String(this.userProfile.counter_detail.phone));
      }
      cmds += newLine;
      cmds += cut;
      console.log(cmds);
      cpj.printerCommands = cmds;
      //Send print job to printer!
      cpj.sendToClient();
    }
    this.clearVariable();
  }
  printReceiptThermal(last_receipt) {
    var dT = new Date(this.transDate+' '+this.transTime);
    let transactionDate = dT;
    let timezoneName = this.userProfile.counter_detail ? this.timezone[parseInt(this.userProfile.counter_detail.timezone)] : this.timezone[0];
    let convertTime = this.utilService.convertDateWithMoment(dT, timezoneName);
    let convertDate = this.utilService.convertDate(transactionDate);

    let monthName: any = this.monthList[(parseInt(convertDate.months)-1)];
    let transDate = convertDate.dates + '-' + monthName + '-' + convertDate.years;
    let transTime = convertTime.hours + ':' + convertTime.minutes + ':' + convertTime.seconds;

    let totalPromo: number = 0;
    let andaHemat :number =0;

    //Create a ClientPrintJob
    const cpj = new JSPM.ClientPrintJob();

    //Set Printer type (Refer to the help, there many of them!)
    if ( this.isDefaultPrinterSelected ) {
      cpj.clientPrinter = new JSPM.DefaultPrinter();
    } else {
      cpj.clientPrinter = new JSPM.InstalledPrinter(this.selectedPrinter);
    }

    //Set content to print...
    //Create ESP/POS commands for sample label
    let esc = '\x1B'; //ESC byte in hex notation
    let newLine = '\x0A'; //LF byte in hex notation
    let cut = "\x1b" + "\x69";
    let cmds = esc + "@"; //Initializes the printer (ESC @)
    
    let center = esc + 'a' + '\x01'; // Align center
    let left   = esc + 'a' + '\x00';    
    let dash = center+'----------------------------------------';
    cmds += esc + '!' + '\x00'; //Character font A selected (ESC ! 0)
    cmds += esc + '*' + '\x32'; //Character font A selected (ESC ! 0)
    
    cmds += newLine;
    cmds += center+this.getLabelHeaderReceipt(String(this.companyName));
    cmds += newLine;
    if(this.receiptName!=''){
      cmds += center+this.getLabelHeaderReceipt(String(this.receiptName));
      cmds += newLine;
    }
    cmds += center+this.getLabelHeaderReceipt(String(this.userProfile.counter_detail.counter_name));
    cmds += newLine;
    if(this.companyNpwp!=''){
      cmds += this.getLabelHeaderReceipt("NPWP : " +String(this.companyNpwp));
      cmds += newLine;
    }
    cmds += center+this.getLabelHeaderReceipt(String(this.companyAddress));
    cmds += newLine;
    if(this.userProfile.counter_detail.phone !== null && this.userProfile.counter_detail.phone !== '') {
      cmds += this.getLabelHeaderReceipt(String(this.userProfile.counter_detail.phone));
    }
    cmds += newLine;
    cmds += dash;
    cmds += newLine;
    cmds += left+'    NO STRUK : ' + this.receiptNo;
    cmds += newLine;
    cmds += '    TANGGAL  : ' + transDate + ' ' + transTime;
    cmds += newLine;
    cmds += '    KASIR    : ' + this.cashierName.toUpperCase();
    cmds += newLine;
    if(this.stickerNumber!='' && this.stickerNumber !== null){
      cmds += '    NAMA BA  : ' + this.stickerNumber.toUpperCase();
      cmds += newLine;
    }
    
    cmds += dash;
    cmds += newLine+left;
    //Start List Barang Belanja    
    let totalDiskonFreeItem =0;
    for(let i = 0; i < this.productSales.length; i++) {
      let sales_transaction_detail_id: any = parseInt(this.productSales[i].sales_transaction_detail_id);
      if(this.productSales[i].typePromo !== 'FREE ITEM (ITEM)' && this.productSales[i].typePromo !== 'FREE ITEM (NOMINAL)') {
        let priceProduct: number = parseInt(this.productSales[i].price);
        let qtyBuy: number = parseInt(this.productSales[i].qty);
        let nettProduct: number = priceProduct * qtyBuy;
        let qtyFree: number = parseInt(this.productSales[i].qtyFree);
        let nettFree: number = priceProduct * qtyFree;
        if(this.productSales[i].qtyFree > 0) {
          if(qtyBuy>0){
            let lblPriceXQty: String = qtyBuy + ' x ' + this.formatRupiah(priceProduct.toString());
            let lblNettProduct: String = this.getLblNett(this.formatRupiah(nettProduct.toString()), lblPriceXQty.length);
            cmds += '    '+this.productSales[i].initialName;
            cmds += newLine;
            cmds += '    '+lblPriceXQty.toString() + lblNettProduct.toString();
            cmds += newLine;
          }
          /*let lblPriceXQtyFree: String = 'FREE ' + qtyFree + ' x ' + this.formatRupiah(priceProduct.toString());
          let lblNettFree: String = this.getLblNett('('+this.formatRupiah(nettFree.toString())+')', lblPriceXQtyFree.length);
          cmds += '    '+this.productSales[i].initialName;
          cmds += newLine;
          cmds += '    '+lblPriceXQtyFree.toString() + lblNettFree.toString();
          cmds += newLine;*/
          totalDiskonFreeItem+=nettFree;
        } else {
          let lblPriceXQty: String = qtyBuy + ' x ' + this.formatRupiah(priceProduct.toString());
          let lblNettProduct: String = this.getLblNett(this.formatRupiah(nettProduct.toString()), lblPriceXQty.length);
          cmds += '    '+this.productSales[i].initialName;
          cmds += newLine;
          cmds += '    '+lblPriceXQty.toString() + lblNettProduct.toString();
          cmds += newLine;
        }
        
        if(this.salesDetailIsiHampers.length>0){
          cmds += newLine;
          let isi = this.salesDetailIsiHampers.filter(x=>x.sales_transaction_detail_id==sales_transaction_detail_id);
          if(isi.length>0){
            for(let ih=0;ih<isi.length;ih++){
              let qty_isi = parseInt(isi[ih].qty);
              let lblIsiHamper = this.getLblIsiHamper(isi[ih].product_name,qty_isi,1)
              cmds += '    '+lblIsiHamper;
              cmds += newLine;
            }
          }
        }
      }

      if(this.productSales[i].typePromo === 'FREE ITEM (ITEM)' || this.productSales[i].typePromo === 'FREE ITEM (NOMINAL)') {
        let price: number = parseInt(this.productSales[i].priceAfterPromo);
        let qty: number = parseInt(this.productSales[i].qtyFree);
        let nett: number = price * qty;
        /*let lblPriceAndQty: String = 'FREE ' + qty + ' x ' + this.formatRupiah(price.toString());
        let lblNett: String = this.getLblNett('('+this.formatRupiah(nett.toString())+')', lblPriceAndQty.length);
        cmds += '    '+this.productSales[i].initialName;
        cmds += newLine;
        cmds += '    '+lblPriceAndQty.toString() + lblNett.toString();
        cmds += newLine;*/        
        totalDiskonFreeItem+=nett;
      }
    }
    //End List Barang Belanja
    cmds +=  dash;
    cmds += newLine;
    
    //Start Detail Promo Product
    for(let i = 0; i < this.productSales.length; i++) {
      if(this.productSales[i].typePromo !== 'FREE ITEM (ITEM)' && this.productSales[i].typePromo !== 'FREE ITEM (NOMINAL)') {
        if(this.productSales[i].typePromo === 'NOMINAL' || this.productSales[i].typePromo === 'PERSENTASE') {
          let countPromoDiff: number = this.productSales[i].discNonRedeem;//(this.productSales[i].price * this.productSales[i].qty) - (this.productSales[i].priceAfterPromo * this.productSales[i].qty);
          totalPromo = totalPromo + countPromoDiff;
          /*let strCountPromoDiff: string = '(' + this.formatRupiah(countPromoDiff.toString()) + ')';
          let lblCountPromo: String = this.getLabelPrintNominal(strCountPromoDiff);

          cmds += left+'    '+this.productSales[i].initialName;
          cmds += newLine;
          cmds += center+'            DISKON : ' + lblCountPromo;
          cmds += newLine;*/
        } else {
          if(this.productSales[i].valPromoNominal !== 0 || this.productSales[i].valPromoPercentage !== 0) {
            let countPromo: number = this.productSales[i].discNonRedeem;;//((this.productSales[i].price * this.productSales[i].qty) * (this.productSales[i].valPromoPercentage / 100)) + this.productSales[i].valPromoNominal;
            totalPromo = totalPromo + countPromo;
            /*let strCountPromoDiff: string = '(' + this.formatRupiah(countPromo.toString()) + ')';
            let lblCountPromo: String = this.getLabelPrintNominal(strCountPromoDiff);

            cmds += left+'    '+this.productSales[i].initialName;
            cmds += newLine;
            cmds += center+'            DISKON : ' + lblCountPromo;
            cmds += newLine;*/
          }
        }
      }        
      if(this.productSales[i].qtyFree>0 ) {
        andaHemat += (this.productSales[i].price * this.productSales[i].qtyFree);
      }      
    }
    andaHemat+=totalPromo
    andaHemat+=this.voucherValue;
    let lblTotalPromo: String = this.getLabelPrintNominal(this.formatRupiah(andaHemat.toString()));
    cmds += '      TOTAL DISKON : ' + lblTotalPromo;
    cmds += newLine;
    let hargaJual =totalDiskonFreeItem+this.totalPaymentWithoutPromo;
    let lblPaymentWithoutPromo: String = this.getLabelPrintNominal(this.formatRupiah(hargaJual.toString()));
    cmds += '      HARGA JUAL   : ' + lblPaymentWithoutPromo;
    cmds += newLine;
    //End Detail Promo Product
    let totalItemPrice = this.totalPaymentWithoutPromo-totalPromo - this.voucherValue;
    cmds +=  dash;
    cmds += newLine;
    let lblTotalPayment: String = this.getLabelPrintNominal(this.formatRupiah(totalItemPrice.toString()));
    let lblTotalItem: String = this.getLabelTotalItem(this.totalItem);
    cmds += '' + lblTotalItem + lblTotalPayment;
    cmds += newLine;
    let lblTotalCustomerCash: String = this.getLabelPrintNominal(this.formatRupiah(this.totalCustomerCash.toString()));
    cmds += '             TUNAI : ' + lblTotalCustomerCash;
    cmds += newLine;
    //Start transfer
    if(this.customerTransfer !== 0) {
      let lblCustomerTransfer: String = this.getLabelPrintNominal(this.formatRupiah(this.customerTransfer.toString()));
      cmds += '          TRANSFER : ' + lblCustomerTransfer;
      cmds += newLine;
    }
    //Start Pembayaran Non Tunai
    if(this.customerCredit !== 0 && this.customerCredit !== null) {
      let lblCustomerCredit: String = this.getLabelPrintNominal(this.formatRupiah(this.customerCredit.toString()));
      cmds += '            KREDIT : ' + lblCustomerCredit;
      cmds += newLine;
    }
    if(this.customerDebit !== 0 && this.customerDebit !== null) {
      let lblCustomerDebit: String = this.getLabelPrintNominal(this.formatRupiah(this.customerDebit.toString()));
      cmds += '             DEBIT : ' + lblCustomerDebit;
      cmds += newLine;
    }
    //End Pembayaran Non Tunai
    //Start Penggunaan Point
    if(this.salesData.member_point!=0) {
      let lblPointValue: String = this.getLabelPrintNominal(this.formatRupiah(this.salesData.member_point.toString()));
      cmds += '          POINT RP : ' + lblPointValue;
      cmds += newLine
    }
    //End Penggunaan Point

    //Start Payment Voucher
    if(this.paymentVoucher !== 0) {
      let lblVoucherValue: String = this.getLabelPrintNominal(this.formatRupiah(this.paymentVoucher.toString()));
      cmds += 'VOUCHER PEMBAYARAN : ' + lblVoucherValue;
      cmds += newLine;
    }
    //End  Payment Voucher

    let lblTotalChange: String = this.getLabelPrintNominal(this.formatRupiah(this.totalChange.toString()));
    cmds += '        KEMBALI RP : ' + lblTotalChange;
    cmds += newLine;
    let finalPayment =totalItemPrice;
    let dpp =Math.round((finalPayment/1.11)*(11/12));
    let lblDpp: String = this.getLabelPrintNominal(this.formatRupiah(dpp.toString()));
    cmds += '               DPP : ' + lblDpp;
    cmds += newLine;
    let ppn = Math.round(dpp * (12/100));
    let lblTotalPpn: String = this.getLabelPrintNominal(this.formatRupiah(ppn.toString()));
    cmds += '               PPN : ' + lblTotalPpn;
    cmds += newLine;
    cmds +=  dash;
    
    if(this.paymentVoucherCode !== '' && this.paymentVoucherCode!= null) {
      cmds += newLine+left;
      cmds += '    KODE VOUCHER PEMBAYARAN    : ';
      cmds += newLine;
      cmds += '    '+this.paymentVoucherCode;
      cmds += newLine;
      cmds += dash;
    }
    
    if(this.voucherValue !== 0 && this.voucherCode!=null && this.voucherCode!='') {
      cmds += newLine+left;
      cmds += '    KODE VOUCHER POTONGAN    : ';
      cmds += newLine;
      cmds += '    '+this.voucherCode;
      cmds += newLine;
      cmds += dash;
    }
     
    if(this.memberPhone !== '') {
      if(this.memberName!='' && this.memberName!=null){
        cmds += newLine+left;
        cmds += '    NAMA MEMBER: ' + this.memberName;
      }
      cmds += newLine+left;
      cmds += '    PHONE : ' + this.memberPhone;
      if(this.showReferralCodeInStruck==true){
        cmds += newLine;
        cmds += '    REFERRAL CODE : ' + this.referralCode;
      }
      let totalLength=21;
      let lblEarrlyPoint: String = this.getLabelPrintPoint(this.formatRupiah(this.earlyPoint.toString()),totalLength);
      let lblInPoint: String = this.getLabelPrintPoint(this.formatRupiah(this.inPoint.toString()),totalLength);
      let lblOutPoint: String = this.getLabelPrintPoint(this.formatRupiah(this.outPoint.toString()),totalLength);
      let lblEndPoint: String = this.getLabelPrintPoint(this.formatRupiah(this.endPoint.toString()),totalLength);
      if(this.endPoint>0){
        cmds += newLine;
        cmds += '    POIN AWAL       : ' + lblEarrlyPoint;
        cmds += newLine;
        cmds += '    POIN DIDAPATKAN : ' + lblInPoint;
        cmds += newLine;
        cmds += '    POIN DIPAKAI    : ' + lblOutPoint;
        cmds += newLine;
        cmds += '    POIN AKHIR      : ' + lblEndPoint;
      }
      if(this.expiringPoin.length>0){
        let namaBulan = [
          'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
          'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'
        ];
        cmds += newLine;
        cmds += '    POIN YANG AKAN EXPIRED ';
        cmds += newLine;
        cmds += '    TGL EXP           | JUMLAH POIN ';
        for(let ep=0;ep<this.expiringPoin.length;ep++){
          let convertEpDate = this.utilService.convertDate(this.expiringPoin[ep].expired_date);
          let bulanEpIndex = Number(convertEpDate.months) -1 ;
          this.expiringPoin[ep].ep_date = convertEpDate.dates + ' ' + namaBulan[bulanEpIndex] + ' ' + convertEpDate.years;
          let lblexpPoint: String = this.getLabelPrintPoint(this.formatRupiah(this.expiringPoin[ep].point_remains.toString()),13);
          let lblepDate: String = this.getLabelPrintPoint(this.expiringPoin[ep].ep_date.toString(),17);
          cmds += newLine;
          cmds += '    '+lblepDate + ' | '+lblexpPoint ;
        }
      }
      cmds += newLine;
      cmds +=  dash;
      if(this.customerItem.length>0){
        cmds += newLine+left;
        cmds += '    BARANG DIBAWA PELANGGAN';
        for(let i=0;i<this.customerItem.length;i++){
          cmds+=newLine;
          cmds += '    '+this.customerItem[i].item_name + ' : '+this.customerItem[i].item_qty;
        }
        cmds+=newLine;
        cmds +=  dash;
      }
    }
    //End detail Member Point
    
    cmds += newLine;
    cmds += newLine;
    cmds += center+'    BARANG YANG SUDAH DIBELI TIDAK ';
    cmds += newLine;
    cmds += '    DAPAT DITUKAR ATAU DIKEMBALIKAN ';
    cmds += newLine;
    cmds += newLine;
    cmds += '    TERIMA KASIH';
    cmds += newLine;
    cmds += newLine;
    cmds += newLine;
    cmds += newLine;
    cmds += newLine;
    cmds += cut;
    console.log(cmds);
    cpj.printerCommands = cmds;
    //Send print job to printer!
    cpj.sendToClient();
    if(last_receipt){
      this.clearVariable();
    }
  }

  getLabelPrintPoint(nominal: any,totalLength:number): String {
    let nominalString = new String(nominal);

    let diff: number = totalLength - nominalString.length;
    let lblNominal: String = '';

    if(diff !== 0) {
      for(let i = 0; i < diff; i++) {
        lblNominal = lblNominal + ' ';
      }

      lblNominal = lblNominal + nominalString.toString();
    } else {
      lblNominal = nominalString;
    }

    return lblNominal;
  }
  clearVariable() {
    this.productSales = [];
    this.salesData = undefined;
    this.salesDetailIsiHampers = undefined;
    this.pointMutationData = [];
    this.receiptNo = undefined;
    this.transDate = undefined;
    this.transTime = undefined;
    this.cashierName = '';
    this.totalPaymentWithoutPromo = 0;
    this.totalPayment = 0;
    this.totalItem = 0;
    this.voucherValue = 0;
    this.paymentVoucher = 0;
    this.paymentVoucherCode = '';
    this.pointMutationType = '';
    this.customerCredit = 0;
    this.customerDebit = 0;
    this.memberPhone = '';
    this.memberName='';
    this.totalPointAdd = 0;
    this.memberPointValueUsed = 0;
    this.memberPointValue = 0;
    this.memberPointUsed = 0;
    this.totalChange = 0;
    this.totalCustomerCash = 0;
    this.firstAddress = undefined;
    this.lastAddress = undefined;
    this.counterPhone = undefined;
  }

  calcTotal() {
    this.totalPayment = 0;
    this.totalItem = 0;
    this.totalPaymentWithoutPromo = 0;
    for (let i=0;i < this.productSales.length;i++) {
      this.totalPaymentWithoutPromo += (this.productSales[i].price * (this.productSales[i].qty-this.productSales[i].qtyFree));
      this.totalPayment += this.productSales[i].nett;
      this.totalItem += this.productSales[i].qty;
    }
  }

  formatRupiah(angka: string) {
    var number_string = angka.replace(/[^,\d]/g, '').toString();
    var split = number_string.split(',');
    var sisa = split[0].length % 3;
    var rupiah = split[0].substr(0, sisa);
    var ribuan = split[0].substr(sisa).match(/\d{3}/gi);

    if (ribuan) {
      var separator = sisa ? '.' : '';
      rupiah += separator + ribuan.join('.');
    }

    rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
    return rupiah;
  }

  getLabelPrintNominal(nominal: any): String {
    let nominalString = new String(nominal);
    let totalLength: number = 12;
    if(this.userProfile.counter_detail.printer_type=='thermal'){
      totalLength=19;
    }

    let diff: number = totalLength - nominalString.length;
    let lblNominal: String = '';

    if(diff !== 0) {
      for(let i = 0; i < diff; i++) {
        lblNominal = lblNominal + ' ';
      }
      lblNominal = lblNominal + nominalString.toString();
    } else {
      lblNominal = nominalString;
    }
    return lblNominal;
  }

  getLblNett(nett: String, priceAndQtylength: number): String {
    let lblNominal: String = '';
    let receiptRowLength: number = 33;
    if(this.userProfile.counter_detail.printer_type=='thermal'){
      receiptRowLength = 40;
    }
    else if(this.userProfile.counter_detail.printer_type=='imin_external'){
      receiptRowLength = 48;
    }

    let nettLength: number = nett.length;
    let diff: number = receiptRowLength - (nettLength + priceAndQtylength);
    for(let i = 0; i < diff; i++) {
      lblNominal = lblNominal + ' ';
    }
    lblNominal = lblNominal + nett.toString();
    return lblNominal;
  }

  getLabelDppAndPpn(label: String, lblLength: number): String {
    let lblNominal: String = '';
    let receiptRowLength: number =33;
    if(this.userProfile.counter_detail.printer_type=='thermal'){
      receiptRowLength = 40;
    }
    else if(this.userProfile.counter_detail.printer_type=='imin_external'){
      receiptRowLength = 48;
    }
    let frontLblLength: number = 6;

    let diff: number = receiptRowLength - (frontLblLength + lblLength);
    for(let i = 0; i < diff; i++) {
      lblNominal = lblNominal + ' ';
    }
    lblNominal = lblNominal + label.toString();
    return lblNominal;
  }

  getLabelTotalItem(nominal: any): String {
    let nominalString = new String(nominal);
    let label: String = 'TOTAL ITEM ' + nominalString + ' : ';
    let lblNominal: String = '';
    let totalLength: number = label.length;
    let diff: number = 21 - totalLength;
    if(diff !== 0) {
      let space: any = '';
      for(let i = 0; i < diff; i++) {
        space = space + ' ';
      }
      lblNominal = space + label;
    } else {
      lblNominal = label;
    }
    return lblNominal;
  }
  
  getLabelHeaderReceipt(headerText: string) {
    let maxTextLengthForReceipt = 33;

    if(this.userProfile.counter_detail.printer_type=='thermal'){
      maxTextLengthForReceipt = 34;
    }

    let resultText: string[] = [];

    // Pecah berdasarkan newline
    let lines = headerText.split(/\r?\n/);

    lines.forEach(line => {
      line = line.trim();

      while (line.length > maxTextLengthForReceipt) {

        // Cari posisi spasi terakhir sebelum batas karakter
        let breakPosition = line.lastIndexOf(' ', maxTextLengthForReceipt);

        // Kalau tidak ada spasi, potong paksa
        if (breakPosition <= 0) {
          breakPosition = maxTextLengthForReceipt;
        }

        let currentLine = line.substring(0, breakPosition).trim();

        // Center line
        let diff = maxTextLengthForReceipt - currentLine.length;
        let leftSpace = Math.floor(diff / 2);

        resultText.push(
          ' '.repeat(leftSpace) + currentLine
        );

        line = line.substring(breakPosition).trim();
      }

      // Sisa line
      if (line.length > 0) {
        let diff = maxTextLengthForReceipt - line.length;
        let leftSpace = Math.floor(diff / 2);

        resultText.push(
          ' '.repeat(leftSpace) + line
        );
      }
    });

    return resultText.join('\n');
  }

  getLabelHeaderReceiptOld(headerText: String) {
    let totalLength: number = headerText.length;
    let maxTextLengthforReceipt = 33;
    if(this.userProfile.counter_detail.printer_type=='thermal'){
      maxTextLengthforReceipt = 34;
    }
    let resultText = "";
    if(totalLength > maxTextLengthforReceipt) {
      resultText = headerText.slice(0, maxTextLengthforReceipt);
    } else {
      let diff = maxTextLengthforReceipt - totalLength;
      let divide = (diff - (diff % 2)) / 2;
      let space = "";
      for(let i = 0; i < divide; i++) {
        space = space + " ";
      }
      resultText = space + headerText + space;
    }
    return resultText;
  }
  
  getLblIsiHamper(
    name: string,
    qty: number,
    indent: number = 0,
    receiptRowLength: number = 33,
    maxName: number = 20   // jumlah karakter sebelum dipotong
  ): string {
    const indentStr = " ".repeat(indent);
    const prefix = "- ";
    const qtyStr = "x" + qty;
    const qtyLen = qtyStr.length;
    if(this.userProfile.counter_detail.printer_type=='thermal'){
      receiptRowLength = 40;
    }
    else if(this.userProfile.counter_detail.printer_type=='imin_external'){
      receiptRowLength = 48;
    }

    // potong nama jika kepanjangan
    let shortName = name;
    if (name.length > maxName) {
      shortName = name.substring(0, maxName) + "...";
    }
    const leftPart = indentStr + prefix + shortName;
    let line = leftPart;
    // hitung space untuk qty agar rata kanan
    const spacesNeeded = receiptRowLength - (indentStr.length + prefix.length + shortName.length + qtyLen);
    line += " ".repeat(spacesNeeded) + qtyStr;
    return line;
  }
  async printReceiptImin() {
    var dT = new Date(this.transDate+' '+this.transTime);
    let transactionDate = dT;
    let timezoneName = this.userProfile.counter_detail ? this.timezone[parseInt(this.userProfile.counter_detail.timezone)] : this.timezone[0];
    let convertTime = this.utilService.convertDateWithMoment(dT, timezoneName);
    let convertDate = this.utilService.convertDate(transactionDate);

    let monthName: any = this.monthList[(parseInt(convertDate.months)-1)];
    let transDate = convertDate.dates + '-' + monthName + '-' + convertDate.years;
    let transTime = convertTime.hours + ':' + convertTime.minutes + ':' + convertTime.seconds;

    let totalPromo: number = 0;
    let newLine = "<br>"
    let cmds = '<div style="margin-bottom: 6px; border-bottom: 1px solid #000; padding-bottom: 6px;">';//esc + "@"; //Initializes the printer (ESC @)
    //cmds += esc + '!' + '\x00'; //Character font A selected (ESC ! 0)
    //cmds += esc + '*' + '\x32'; //Character font A selected (ESC ! 0)
    
    cmds += '<div>NO STRUKK: ' + this.receiptNo+'</div>';
    cmds += '<div>TANGGAL  : ' + transDate + ' ' + transTime+'</div>';
    cmds += '<div>KASIR    : ' + this.cashierName.toUpperCase()+'</div>';
    if(this.stickerNumber!=''  && this.stickerNumber !== null){
      cmds += '<div>NAMA BA    : ' + this.stickerNumber.toUpperCase()+'</div>';
    }
    //Start List Barang Belanja
    
    cmds += '<div style="margin-bottom: 6px;">';
    for(let i = 0; i < this.productSales.length; i++) {
      let sales_transaction_detail_id: any = parseInt(this.productSales[i].sales_transaction_detail_id);
      if(this.productSales[i].typePromo !== 'FREE ITEM (ITEM)' && this.productSales[i].typePromo !== 'FREE ITEM (NOMINAL)') {
        let priceProduct: number = parseInt(this.productSales[i].price);
        let qtyBuy: number = parseInt(this.productSales[i].qty);
        let nettProduct: number = priceProduct * qtyBuy;
        let qtyFree: number = parseInt(this.productSales[i].qtyFree);
        let nettFree: number = priceProduct * qtyFree;
        if(this.productSales[i].qtyFree > 0) {
          if(qtyBuy>0){
            let lblPriceXQty: String = qtyBuy + ' x ' + this.formatRupiah(priceProduct.toString());
            let lblNettProduct: String = this.getLblNett(this.formatRupiah(nettProduct.toString()), lblPriceXQty.length);
            cmds+='<div style="margin-bottom: 8px;">';
            cmds+='<div style="font-weight: bold;">'+this.productSales[i].initialName+'</div>';
            cmds+='<div style="display: flex; justify-content: space-between;">';
            cmds+='<span>'+lblPriceXQty.toString() +'</span><span>'+ lblNettProduct.toString()+'</span>';
            cmds+='</div></div>';
            cmds += newLine;
          }
          let lblPriceXQtyFree: String = 'FREE ' + qtyFree + ' x ' + this.formatRupiah(priceProduct.toString());
          let lblNettFree: String = this.getLblNett('('+this.formatRupiah(nettFree.toString())+')', lblPriceXQtyFree.length);
          cmds += this.productSales[i].initialName;
          cmds += newLine;
          cmds += lblPriceXQtyFree.toString() + lblNettFree.toString();
          cmds += newLine;

         // totalPromo = totalPromo + (priceProduct * qtyFree);
        } else {
          let lblPriceXQty: String = qtyBuy + ' x ' + this.formatRupiah(priceProduct.toString());
          let lblNettProduct: String = this.getLblNett(this.formatRupiah(nettProduct.toString()), lblPriceXQty.length);
          cmds+='<div style="margin-bottom: 8px;">';
          cmds+='<div style="font-weight: bold;">'+this.productSales[i].initialName+'</div>';
          cmds+='<div style="display: flex; justify-content: space-between;">';
          cmds+='<span>'+lblPriceXQty.toString() +'</span><span>'+ lblNettProduct.toString()+'</span>';
          cmds+='</div></div>';
        }
        
        if(this.salesDetailIsiHampers.length>0){
          let isi = this.salesDetailIsiHampers.filter(x=>x.sales_transaction_detail_id==sales_transaction_detail_id);
          if(isi.length>0){
            for(let ih=0;ih<isi.length;ih++){
              let qty_isi = parseInt(isi[ih].qty);
              let lblIsiHamper = this.getLblIsiHamper(isi[ih].product_name,qty_isi,1)
              cmds+='<div style="margin-bottom: 8px;">';
              cmds+='<div style="display: flex; justify-content: space-between;">';
              cmds+='<span> - '+isi[ih].product_name.toString() +'</span><span>x'+ qty_isi.toString()+'</span>';
              cmds+='</div></div>';
            }
            cmds += newLine;
          }
        }
      }

      if(this.productSales[i].typePromo === 'FREE ITEM (ITEM)' || this.productSales[i].typePromo === 'FREE ITEM (NOMINAL)') {
        let price: number = parseInt(this.productSales[i].priceAfterPromo);
        let qty: number = parseInt(this.productSales[i].qtyFree);
        let nett: number = price * qty;
        let lblPriceAndQty: String = 'FREE ' + qty + ' x ' + this.formatRupiah(price.toString());
        let lblNett: String = this.getLblNett('('+this.formatRupiah(nett.toString())+')', lblPriceAndQty.length);
        cmds += this.productSales[i].initialName;
        cmds += newLine;
        cmds += lblPriceAndQty.toString() + lblNett.toString();
        cmds += newLine;
      }
    }
    cmds += '</div>';
    //End List Barang Belanja
    cmds+='<div style="border-top: 1px solid #000; margin: 10px 0;"></div>';
    cmds+='<div style="margin-bottom: 8px;">';
    cmds+='<div style="display: flex; justify-content: space-between;">';
    cmds+='<span>HARGA JUAL : </span><span>'+ this.formatRupiah(this.totalPaymentWithoutPromo.toString())+'</span>';
    cmds+='</div></div>';
    //Start Detail Promo Product
    for(let i = 0; i < this.productSales.length; i++) {
      if(this.productSales[i].typePromo !== 'FREE ITEM (ITEM)' && this.productSales[i].typePromo !== 'FREE ITEM (NOMINAL)') {
        if(this.productSales[i].typePromo === 'NOMINAL' || this.productSales[i].typePromo === 'PERSENTASE') {
          let countPromoDiff: number = (this.productSales[i].price * this.productSales[i].qty) - (this.productSales[i].priceAfterPromo * this.productSales[i].qty);
          totalPromo = totalPromo + countPromoDiff;
          let strCountPromoDiff: string = '(' + this.formatRupiah(countPromoDiff.toString()) + ')';
          let lblCountPromo: String = this.getLabelPrintNominal(strCountPromoDiff);

          cmds += this.productSales[i].initialName;
          cmds += newLine;
          cmds += '            DISKON : ' + lblCountPromo;
          cmds += newLine;
        } else {
          if(this.productSales[i].valPromoNominal !== 0 || this.productSales[i].valPromoPercentage !== 0) {
            let countPromo: number = ((this.productSales[i].price * this.productSales[i].qty) * (this.productSales[i].valPromoPercentage / 100)) + this.productSales[i].valPromoNominal;
            totalPromo = totalPromo + countPromo;
            let strCountPromoDiff: string = '(' + this.formatRupiah(countPromo.toString()) + ')';
            let lblCountPromo: String = this.getLabelPrintNominal(strCountPromoDiff);

            cmds += this.productSales[i].initialName;
            cmds += newLine;
            cmds += '            DISKON : ' + lblCountPromo;
            cmds += newLine;
          }
        }
      }

      if(this.productSales[i].typePromo === 'FREE ITEM (ITEM)' || this.productSales[i].typePromo === 'FREE ITEM (NOMINAL)') {
       // totalPromo = totalPromo + (this.productSales[i].priceAfterPromo * this.productSales[i].qtyFree);
      }
        
      if(this.productSales[i].qtyFree>0 ) {
        totalPromo = totalPromo + (this.productSales[i].price * this.productSales[i].qtyFree);
      }
    }
    //End Detail Promo Product
    cmds+='<div style="border-top: 1px solid #000; margin: 10px 0;"></div>';
    
    cmds+='<div style="margin-bottom: 8px;"><hr></div>';
    cmds+='<div style="margin-bottom: 8px;">';
    cmds+='<div style="display: flex; justify-content: space-between;">';
    cmds+='<span>TOTAL ITEM ' + this.totalItem + ' : </span><span>'+ this.formatRupiah(this.totalPayment.toString())+'</span>';
    cmds+='</div></div>';
    cmds+='<div style="margin-bottom: 8px;">';
    cmds+='<div style="display: flex; justify-content: space-between;">';
    cmds+='<span>TUNAI  : </span><span>'+ this.formatRupiah(this.totalCustomerCash.toString())+'</span>';
    cmds+='</div></div>';

    //Start transfer
    if(this.customerTransfer !== 0) {
      cmds+='<div style="margin-bottom: 8px;">';
      cmds+='<div style="display: flex; justify-content: space-between;">';
      cmds+='<span>TRANSFER  : </span><span>'+ this.formatRupiah(this.customerTransfer.toString())+'</span>';
      cmds+='</div></div>';
    }

    //Start Pembayaran Non Tunai
    if(this.customerCredit !== 0 && this.customerCredit !== null) {
      cmds+='<div style="margin-bottom: 8px;">';
      cmds+='<div style="display: flex; justify-content: space-between;">';
      cmds+='<span>KREDIT  : </span><span>'+ this.formatRupiah(this.customerCredit.toString())+'</span>';
      cmds+='</div></div>';
    }
    if(this.customerDebit !== 0 && this.customerDebit !== null) {
      cmds+='<div style="margin-bottom: 8px;">';
      cmds+='<div style="display: flex; justify-content: space-between;">';
      cmds+='<span>DEBIT  : </span><span>'+ this.formatRupiah(this.customerDebit.toString())+'</span>';
      cmds+='</div></div>';
    }
    //End Pembayaran Non Tunai

    //Start Penggunaan Point
    if(this.salesData.member_point!=0) {
      cmds+='<div style="margin-bottom: 8px;">';
      cmds+='<div style="display: flex; justify-content: space-between;">';
      cmds+='<span>POINT  RP: </span><span>'+ this.formatRupiah(this.salesData.member_point.toString())+'</span>';
      cmds+='</div></div>';
    }
    //End Penggunaan Point

    //Start Voucher
    if(this.voucherValue !== 0) {
      cmds+='<div style="margin-bottom: 8px;">';
      cmds+='<div style="display: flex; justify-content: space-between;">';
      cmds+='<span>VOUCHER POTONGAN : </span><span>'+ this.formatRupiah(this.voucherValue.toString())+'</span>';
      cmds+='</div></div>';
    }
    //End Voucher
    //Start Payment Voucher
    if(this.paymentVoucher !== 0) {
      cmds+='<div style="margin-bottom: 8px;">';
      cmds+='<div style="display: flex; justify-content: space-between;">';
      cmds+='<span>VOUCHER PEMBAYARAN  : </span><span>'+ this.formatRupiah(this.paymentVoucher.toString())+'</span>';
      cmds+='</div></div>';
    }
    //End Payment Voucher
    cmds+='<div style="margin-bottom: 8px;">';
    cmds+='<div style="display: flex; justify-content: space-between;">';
    cmds+='<span>KEMBALI RP  : </span><span>'+ this.formatRupiah(this.totalChange.toString())+'</span>';
    cmds+='</div></div>';
    
    cmds+='<div style="margin-bottom: 8px;">';
    cmds+='<div style="display: flex; justify-content: space-between;">';
    cmds+='<span>ANDA HEMAT  : </span><span>'+ this.formatRupiah(totalPromo.toString())+'</span>';
    cmds+='</div></div>';
    if(this.paymentVoucher !== 0) {    
      cmds+='<div style="margin-bottom: 8px;">';
      cmds+='<div style="display: flex; justify-content: space-between;">';
      cmds+='<span>KODE VOUCHER PEMBAYARAN: </span><span>'+ this.paymentVoucherCode+'</span>';
      cmds+='</div></div>';
    }
    if(this.voucherValue !== 0) {    
      cmds+='<div style="margin-bottom: 8px;">';
      cmds+='<div style="display: flex; justify-content: space-between;">';
      cmds+='<span>KODE VOUCHER POTONGAN: </span><span>'+ this.voucherCode+'</span>';
      cmds+='</div></div>';
    }
     
    if(this.memberPhone !== '') {
      cmds+='<div style="border-top: 1px solid #000; margin: 10px 0;"></div>';
      if(this.memberName!='' && this.memberName!=null){
        cmds+='<div style="margin-bottom: 8px;">';
        cmds+='<div style="display: flex; justify-content: space-between;">';
        cmds+='<span>MEMBER: </span><span>'+ this.memberName+'</span>';
        cmds+='</div></div>';
      }
      cmds+='<div style="margin-bottom: 8px;">';
      cmds+='<div style="display: flex; justify-content: space-between;">';
      cmds+='<span>PHONE: </span><span>'+ this.memberPhone+'</span>';
      cmds+='</div></div>';
      if(this.showReferralCodeInStruck==true){
        cmds+='<div style="margin-bottom: 8px;">';
        cmds+='<div style="display: flex; justify-content: space-between;">';
        cmds+='<span>REFERRAL CODE: </span><span>'+ this.referralCode+'</span>';
        cmds+='</div></div>';
      }
      if(this.endPoint>0){
        cmds+='<div style="margin-bottom: 8px;">';
        cmds+='<div style="display: flex; justify-content: space-between;">';
        cmds+='<span>POIN AWAL: </span><span>'+ this.formatRupiah(this.earlyPoint.toString())+'</span>';
        cmds+='</div></div>';
        cmds+='<div style="margin-bottom: 8px;">';
        cmds+='<div style="display: flex; justify-content: space-between;">';
        cmds+='<span>POIN DIDAPATKAN: </span><span>'+ this.formatRupiah(this.inPoint.toString())+'</span>';
        cmds+='</div></div>';
        cmds+='<div style="margin-bottom: 8px;">';
        cmds+='<div style="display: flex; justify-content: space-between;">';
        cmds+='<span>POIN DIPAKAI: </span><span>'+ this.formatRupiah(this.outPoint.toString())+'</span>';
        cmds+='</div></div>';
        cmds+='<div style="margin-bottom: 8px;">';
        cmds+='<div style="display: flex; justify-content: space-between;">';
        cmds+='<span>POIN AKHIR: </span><span>'+ this.formatRupiah(this.endPoint.toString())+'</span>';
        cmds+='</div></div>';
      }
      if(this.expiringPoin.length>0){
        let namaBulan = [
          'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
          'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'
        ];
        cmds+='<div style="margin-bottom: 8px;">';
        cmds+='<div>POIN YANG AKAN EXPIRED</div>';
        cmds+='<div style="display: flex; justify-content: space-between;">';
        cmds+='<span>TGL EXP |  </span><span>JUMLAH POIN</span>';
        for(let ep=0;ep<this.expiringPoin.length;ep++){
          let convertEpDate = this.utilService.convertDate(this.expiringPoin[ep].expired_date);
          let bulanEpIndex = Number(convertEpDate.months) -1 ;
          this.expiringPoin[ep].ep_date = convertEpDate.dates + ' ' + namaBulan[bulanEpIndex] + ' ' + convertEpDate.years;
          cmds+='<span>'+this.expiringPoin[ep].ep_date.toString()+'</span><span>'+this.formatRupiah(this.expiringPoin[ep].point_remains.toString())+'</span>';
          cmds += newLine;
        }
        cmds+='</div></div>';
      }
      if(this.customerItem.length>0){
        cmds += newLine;
        cmds+='<div style="border-top: 1px solid #000; margin: 10px 0;"></div>';
        cmds += newLine;
          cmds+='<div style="margin-bottom: 8px;">';
        cmds += '<div>BARANG DIBAWA PELANGGAN</div>';
        
        for(let i=0;i<this.customerItem.length;i++){
          cmds+=newLine;
          cmds+='<div style="display: flex; justify-content: space-between;">';
          cmds+='<span>'+this.customerItem[i].item_name+' </span><span>'+ this.customerItem[i].item_qty+'</span>';
          cmds+='</div>';
        }
        cmds+='</div>';
        cmds+=newLine;
        cmds+='<div style="border-top: 1px solid #000; margin: 10px 0;"></div>';
        
      }
    }
    //End detail Member Point

    cmds += newLine;
    cmds += '<p style="text-align:center"> BARANG YANG SUDAH DIBELI TIDAK ';
    cmds += newLine;
    cmds += ' DAPAT DITUKAR ATAU DIKEMBALIKAN ';
    cmds += newLine;
    /*cmds += newLine;
    cmds += ' JIKA MEMILIKI PERTANYAAN, SARAN,';
    cmds += newLine;
    cmds += '    ATAU KRITIK, HUBUNGI KAMI ';
    cmds += newLine;
    cmds += '     DI 081138911248 ATAU ';
    cmds += newLine;
    cmds += ' EMAIL: CS@SECRETGARDEN.CO.ID ';
    cmds += newLine;*/
    cmds += '           TERIMA KASIH</p>';
    cmds += newLine;
    cmds += newLine;
    cmds += newLine;
    cmds += "<p style='text-align:center'>"+this.getLabelHeaderReceipt(String(this.receiptName));
    cmds += newLine;
    cmds += this.getLabelHeaderReceipt(String(this.userProfile.counter_detail.counter_name));
    cmds += newLine;
    cmds += this.getLabelHeaderReceipt(String(this.userProfile.counter_detail.first_address));
    cmds += newLine;
    cmds += this.getLabelHeaderReceipt(String(this.userProfile.counter_detail.last_address));
    cmds += newLine;
    if(this.userProfile.counter_detail.phone !== null && this.userProfile.counter_detail.phone !== '') {
      cmds += this.getLabelHeaderReceipt(String(this.userProfile.counter_detail.phone));
    }
    cmds+='</p>';
    cmds += newLine;
    const container = document.getElementById('strukArea');
    container.innerHTML = cmds;
    
   const imageBase64 = await this.convertToImage();
    await this.printerImin.initPrinter("SPI"); // MODE ESC/POS // wajib sebelum print
    const result = await this.printerImin.printSingleBitmap(imageBase64);
    await this.printerImin.printAndFeedPaper(100);
    await this.printerImin.partialCut()
    // buat URL download*/
    const base64 = imageBase64.split(',')[1];
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'image/png' });
    const url = URL.createObjectURL(blob);
    //window.open(url);

    this.clearVariable();
  }
  async convertToImage() {
    const element = document.getElementById('strukArea') as HTMLElement;
    const canvas = await html2canvas(element, {
      backgroundColor: "#ffffff",
      scale: 1, width: 500,        // wajib <= 384
      windowWidth: 500, 
    });
    const imgData = canvas.toDataURL("image/png");
    return imgData;
  }
  
  async printReceiptIminExternalOld() {
    var dT = new Date(this.transDate+' '+this.transTime);
    let transactionDate = dT;
    let timezoneName = this.userProfile.counter_detail ? this.timezone[parseInt(this.userProfile.counter_detail.timezone)] : this.timezone[0];
    let convertTime = this.utilService.convertDateWithMoment(dT, timezoneName);
    let convertDate = this.utilService.convertDate(transactionDate);

    let monthName: any = this.monthList[(parseInt(convertDate.months)-1)];
    let transDate = convertDate.dates + '-' + monthName + '-' + convertDate.years;
    let transTime = convertTime.hours + ':' + convertTime.minutes + ':' + convertTime.seconds;

    let totalPromo: number = 0;
    let newLine = "<br>"
    let cmds = '<div style="margin-bottom: 6px; border-bottom: 1px solid #000; padding-bottom: 6px;font-family: monospace;font-size: 2.4mm;">';//esc + "@"; //Initializes the printer (ESC @)
    let line ='<div style="border-top: 1px dashed #000; margin: 10px 0;"></div>';
    //cmds += esc + '!' + '\x00'; //Character font A selected (ESC ! 0)
    //cmds += esc + '*' + '\x32'; //Character font A selected (ESC ! 0)
    
    cmds += "<p style='text-align:center'>"+this.getLabelHeaderReceipt(String(this.receiptName));
    cmds += newLine;
    cmds += this.getLabelHeaderReceipt(String(this.userProfile.counter_detail.counter_name));
    cmds += newLine;
    cmds += this.getLabelHeaderReceipt(String(this.userProfile.counter_detail.first_address));
    cmds += newLine;
    cmds += this.getLabelHeaderReceipt(String(this.userProfile.counter_detail.last_address));
    cmds += newLine;
    if(this.userProfile.counter_detail.phone !== null && this.userProfile.counter_detail.phone !== '') {
      cmds += this.getLabelHeaderReceipt(String(this.userProfile.counter_detail.phone));
    }
    cmds+='</p>';
    cmds+=line;
    cmds += '<div>NO STRUK: ' + this.receiptNo+'</div>';
    cmds += '<div>TANGGAL  : ' + transDate + ' ' + transTime+'</div>';
    cmds += '<div>KASIR    : ' + this.cashierName.toUpperCase()+'</div>';
    if(this.stickerNumber!='' && this.stickerNumber !== null){
      cmds += '<div>NAMA BA    : ' + this.stickerNumber.toUpperCase()+'</div>';
    }
    cmds+=line;
    //Start List Barang Belanja
    cmds += '<div style="margin-bottom: 6px;">';
    for(let i = 0; i < this.productSales.length; i++) {
      let sales_transaction_detail_id: any = parseInt(this.productSales[i].sales_transaction_detail_id);
      if(this.productSales[i].typePromo !== 'FREE ITEM (ITEM)' && this.productSales[i].typePromo !== 'FREE ITEM (NOMINAL)') {
        let priceProduct: number = parseInt(this.productSales[i].price);
        let qtyBuy: number = parseInt(this.productSales[i].qty);
        let nettProduct: number = priceProduct * qtyBuy;
        let qtyFree: number = parseInt(this.productSales[i].qtyFree);
        let nettFree: number = priceProduct * qtyFree;
        if(this.productSales[i].qtyFree > 0) {
          if(qtyBuy>0){
            let lblPriceXQty: String = qtyBuy + ' x ' + this.formatRupiah(priceProduct.toString());
            let lblNettProduct: String = this.getLblNett(this.formatRupiah(nettProduct.toString()), lblPriceXQty.length);
            cmds+='<div style="margin-bottom: 8px;">';
            cmds+='<div>'+this.productSales[i].initialName+'</div>';
            cmds+='<div style="display: flex; justify-content: space-between;">';
            cmds+='<span>'+lblPriceXQty.toString() +'</span><span>'+ lblNettProduct.toString()+'</span>';
            cmds+='</div></div>';
          }
          let lblPriceXQtyFree: String = 'FREE ' + qtyFree + ' x ' + this.formatRupiah(priceProduct.toString());
          let lblNettFree: String = this.getLblNett('('+this.formatRupiah(nettFree.toString())+')', lblPriceXQtyFree.length);
          cmds+='<div style="margin-bottom: 8px;">';
          cmds+='<div>'+this.productSales[i].initialName+'</div>';
          cmds+='<div style="display: flex; justify-content: space-between;">';
          cmds+='<span>'+lblPriceXQtyFree.toString() +'</span><span>'+ lblNettFree.toString()+'</span>';
          cmds+='</div></div>';
        } else {
          let lblPriceXQty: String = qtyBuy + ' x ' + this.formatRupiah(priceProduct.toString());
          let lblNettProduct: String = this.getLblNett(this.formatRupiah(nettProduct.toString()), lblPriceXQty.length);
          cmds+='<div style="margin-bottom: 8px;">';
          cmds+='<div>'+this.productSales[i].initialName+'</div>';
          cmds+='<div style="display: flex; justify-content: space-between;">';
          cmds+='<span>'+lblPriceXQty.toString() +'</span><span>'+ lblNettProduct.toString()+'</span>';
          cmds+='</div></div>';
        }
        
        if(this.salesDetailIsiHampers.length>0){
          let isi = this.salesDetailIsiHampers.filter(x=>x.sales_transaction_detail_id==sales_transaction_detail_id);
          if(isi.length>0){
            for(let ih=0;ih<isi.length;ih++){
              let qty_isi = parseInt(isi[ih].qty);
              let lblIsiHamper = this.getLblIsiHamper(isi[ih].product_name,qty_isi,1)
              cmds+='<div style="margin-bottom: 8px;">';
              cmds+='<div style="display: flex; justify-content: space-between;">';
              cmds+='<span> - '+isi[ih].product_name.toString() +'</span><span>x'+ qty_isi.toString()+'</span>';
              cmds+='</div></div>';
            }
          }
        }
      }

      if(this.productSales[i].typePromo === 'FREE ITEM (ITEM)' || this.productSales[i].typePromo === 'FREE ITEM (NOMINAL)') {
        let price: number = parseInt(this.productSales[i].priceAfterPromo);
        let qty: number = parseInt(this.productSales[i].qtyFree);
        let nett: number = price * qty;
        let lblPriceAndQty: String = 'FREE ' + qty + ' x ' + this.formatRupiah(price.toString());
        let lblNett: String = this.getLblNett('('+this.formatRupiah(nett.toString())+')', lblPriceAndQty.length);
        cmds+='<div style="margin-bottom: 8px;">';
        cmds+='<div>'+this.productSales[i].initialName+'</div>';
        cmds+='<div style="display: flex; justify-content: space-between;">';
        cmds+='<span>'+lblPriceAndQty.toString() +'</span><span>'+ lblNett.toString()+'</span>';
        cmds+='</div></div>';
      }
    }
    cmds += '</div>';
    //End List Barang Belanja
    cmds+=line;
    cmds+='<div style="margin-bottom: 8px;">';
    cmds+='<div style="display: flex; justify-content: space-between;">';
    cmds+='<span>HARGA JUAL : </span><span>'+ this.formatRupiah(this.totalPaymentWithoutPromo.toString())+'</span>';
    cmds+='</div></div>';
    //Start Detail Promo Product
    for(let i = 0; i < this.productSales.length; i++) {
      if(this.productSales[i].typePromo !== 'FREE ITEM (ITEM)' && this.productSales[i].typePromo !== 'FREE ITEM (NOMINAL)') {
        if(this.productSales[i].typePromo === 'NOMINAL' || this.productSales[i].typePromo === 'PERSENTASE') {
          let countPromoDiff: number = (this.productSales[i].price * this.productSales[i].qty) - (this.productSales[i].priceAfterPromo * this.productSales[i].qty);
          totalPromo = totalPromo + countPromoDiff;
          let strCountPromoDiff: string = '(' + this.formatRupiah(countPromoDiff.toString()) + ')';
          let lblCountPromo: String = this.getLabelPrintNominal(strCountPromoDiff);
          cmds += '<div>'+this.productSales[i].initialName+'</div>';
          cmds+='<div style="margin-bottom: 8px;">';
          cmds+='<div style="display: flex; justify-content: space-between;">';
          cmds+='<span>            DISKON : </span><span>'+ lblCountPromo+'</span>';
          cmds+='</div></div>';
        } else {
          if(this.productSales[i].valPromoNominal !== 0 || this.productSales[i].valPromoPercentage !== 0) {
            let countPromo: number = this.productSales[i].discNonRedeem;
            totalPromo = totalPromo + countPromo;
            let strCountPromoDiff: string = '(' + this.formatRupiah(countPromo.toString()) + ')';
            let lblCountPromo: String = this.getLabelPrintNominal(strCountPromoDiff);
            cmds += '<div>'+this.productSales[i].initialName+'</div>';
            cmds+='<div style="margin-bottom: 8px;">';
            cmds+='<div style="display: flex; justify-content: space-between;">';
            cmds+='<span>            DISKON : </span><span>'+ lblCountPromo+'</span>';
            cmds+='</div></div>';
          }
        }
      }

      if(this.productSales[i].typePromo === 'FREE ITEM (ITEM)' || this.productSales[i].typePromo === 'FREE ITEM (NOMINAL)') {
       // totalPromo = totalPromo + (this.productSales[i].priceAfterPromo * this.productSales[i].qtyFree);
      }
        
      if(this.productSales[i].qtyFree>0 ) {
        totalPromo = totalPromo + (this.productSales[i].price * this.productSales[i].qtyFree);
      }
    }
    //End Detail Promo Product
    cmds+=line;
    cmds+='<div style="margin-bottom: 8px;">';
    cmds+='<div style="display: flex; justify-content: space-between;">';
    cmds+='<span>TOTAL ITEM ' + this.totalItem + ' : </span><span>'+ this.formatRupiah(this.totalPayment.toString())+'</span>';
    cmds+='</div></div>';
    cmds+='<div style="margin-bottom: 8px;">';
    cmds+='<div style="display: flex; justify-content: space-between;">';
    cmds+='<span>TUNAI  : </span><span>'+ this.formatRupiah(this.totalCustomerCash.toString())+'</span>';
    cmds+='</div></div>';

    //Start transfer
    if(this.customerTransfer !== 0) {
      cmds+='<div style="margin-bottom: 8px;">';
      cmds+='<div style="display: flex; justify-content: space-between;">';
      cmds+='<span>TRANSFER  : </span><span>'+ this.formatRupiah(this.customerTransfer.toString())+'</span>';
      cmds+='</div></div>';
    }
    //Start Pembayaran Non Tunai
    if(this.customerCredit !== 0 && this.customerCredit !== null) {
      cmds+='<div style="margin-bottom: 8px;">';
      cmds+='<div style="display: flex; justify-content: space-between;">';
      cmds+='<span>KREDIT  : </span><span>'+ this.formatRupiah(this.customerCredit.toString())+'</span>';
      cmds+='</div></div>';
    }
    if(this.customerDebit !== 0 && this.customerDebit !== null) {
      cmds+='<div style="margin-bottom: 8px;">';
      cmds+='<div style="display: flex; justify-content: space-between;">';
      cmds+='<span>DEBIT  : </span><span>'+ this.formatRupiah(this.customerDebit.toString())+'</span>';
      cmds+='</div></div>';
    }
    //End Pembayaran Non Tunai
    //Start Penggunaan Point
    if(this.salesData.member_point!=0) {
      cmds+='<div style="margin-bottom: 8px;">';
      cmds+='<div style="display: flex; justify-content: space-between;">';
      cmds+='<span>POINT  RP: </span><span>'+ this.formatRupiah(this.salesData.member_point.toString())+'</span>';
      cmds+='</div></div>';
    }
    //End Penggunaan Point

    //Start Voucher
    if(this.voucherValue !== 0) {
      cmds+='<div style="margin-bottom: 8px;">';
      cmds+='<div style="display: flex; justify-content: space-between;">';
      cmds+='<span>VOUCHER POTONGAN : </span><span>'+ this.formatRupiah(this.voucherValue.toString())+'</span>';
      cmds+='</div></div>';
    }
    //End Voucher    
    //Start Payment Voucher
    if(this.paymentVoucher !== 0) {
      cmds+='<div style="margin-bottom: 8px;">';
      cmds+='<div style="display: flex; justify-content: space-between;">';
      cmds+='<span>VOUCHER PEMBAYARAN : </span><span>'+ this.formatRupiah(this.paymentVoucher.toString())+'</span>';
      cmds+='</div></div>';
    }
    //End Payment Voucher
    cmds+='<div style="margin-bottom: 8px;">';
    cmds+='<div style="display: flex; justify-content: space-between;">';
    cmds+='<span>KEMBALI RP  : </span><span>'+ this.formatRupiah(this.totalChange.toString())+'</span>';
    cmds+='</div></div>';
    
    cmds+='<div style="margin-bottom: 8px;">';
    cmds+='<div style="display: flex; justify-content: space-between;">';
    cmds+='<span>ANDA HEMAT  : </span><span>'+ this.formatRupiah(totalPromo.toString())+'</span>';
    cmds+='</div></div>';
    cmds += line;
    if(this.paymentVoucherCode !== '' && this.paymentVoucherCode!=null) {    
      cmds+='<div style="margin-bottom: 8px;">';
      cmds+='<div style="display: flex; justify-content: space-between;">';
      cmds+='<span>KODE VOUCHER PEMBAYARAN: </span><span>'+ this.paymentVoucherCode+'</span>';
      cmds+='</div></div>';
      cmds += line;
    }
    if(this.voucherCode !== '' && this.voucherCode!=null) {    
      cmds+='<div style="margin-bottom: 8px;">';
      cmds+='<div style="display: flex; justify-content: space-between;">';
      cmds+='<span>KODE VOUCHER POTONGAN: </span><span>'+ this.voucherCode+'</span>';
      cmds+='</div></div>';
      cmds += line;
    }
     
    if(this.memberPhone !== '') {
      if(this.memberName!='' && this.memberName!=null){
        cmds+='<div style="margin-bottom: 8px;">';
        cmds+='<div style="display: flex; justify-content: space-between;">';
        cmds+='<span>NAMA MEMBER: </span><span>'+ this.memberName+'</span>';
        cmds+='</div></div>';
      }
      cmds+='<div style="margin-bottom: 8px;">';
      cmds+='<div style="display: flex; justify-content: space-between;">';
      cmds+='<span>PHONE: </span><span>'+ this.memberPhone+'</span>';
      cmds+='</div></div>';
      if(this.showReferralCodeInStruck==true){
        cmds+='<div style="margin-bottom: 8px;">';
        cmds+='<div style="display: flex; justify-content: space-between;">';
        cmds+='<span>REFERRAL CODE: </span><span>'+ this.referralCode+'</span>';
        cmds+='</div></div>';
      }
      if(this.endPoint>0){
        cmds+='<div style="margin-bottom: 8px;">';
        cmds+='<div style="display: flex; justify-content: space-between;">';
        cmds+='<span>POIN AWAL: </span><span>'+ this.formatRupiah(this.earlyPoint.toString())+'</span>';
        cmds+='</div></div>';
        cmds+='<div style="margin-bottom: 8px;">';
        cmds+='<div style="display: flex; justify-content: space-between;">';
        cmds+='<span>POIN DIDAPATKAN: </span><span>'+ this.formatRupiah(this.inPoint.toString())+'</span>';
        cmds+='</div></div>';
        cmds+='<div style="margin-bottom: 8px;">';
        cmds+='<div style="display: flex; justify-content: space-between;">';
        cmds+='<span>POIN DIPAKAI: </span><span>'+ this.formatRupiah(this.outPoint.toString())+'</span>';
        cmds+='</div></div>';
        cmds+='<div style="margin-bottom: 8px;">';
        cmds+='<div style="display: flex; justify-content: space-between;">';
        cmds+='<span>POIN AKHIR: </span><span>'+ this.formatRupiah(this.endPoint.toString())+'</span>';
        cmds+='</div></div>';
      }
      if(this.expiringPoin.length>0){
        let namaBulan = [
          'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
          'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'
        ];
        cmds+='<div style="margin-bottom: 8px;">';
        cmds += '<div>POIN YANG AKAN EXPIRED </div>';
        cmds += '<div>TGL EXP           | JUMLAH POIN </div>';
        for(let ep=0;ep<this.expiringPoin.length;ep++){
          let convertEpDate = this.utilService.convertDate(this.expiringPoin[ep].expired_date);
          let bulanEpIndex = Number(convertEpDate.months) -1 ;
          this.expiringPoin[ep].ep_date = convertEpDate.dates + ' ' + namaBulan[bulanEpIndex] + ' ' + convertEpDate.years;
          cmds += `
          <div style="display:flex; font-family:monospace">
            <span style="width:150px">${this.expiringPoin[ep].ep_date.toString()} |</span>
            <span style="width:50px; text-align:right;">${this.formatRupiah(this.expiringPoin[ep].point_remains.toString())}</span>
          </div>
          `;
        }
      }
      cmds += line;
      if(this.customerItem.length>0){
        cmds+='<div style="margin-bottom: 8px;">';
        cmds +='<div>BARANG DIBAWA PELANGGAN</div>';
        for(let i=0;i<this.customerItem.length;i++){
          cmds+='<div style="display: flex; justify-content: space-between;">';
          cmds+='<span>'+this.customerItem[i].item_name+' </span><span>'+ this.customerItem[i].item_qty+'</span>';
          cmds+='</div>';
        }
        cmds+='</div>';
        cmds+= line;
      }
    }
    //End detail Member Point

    cmds += newLine;
    cmds += '<p style="text-align:center"> BARANG YANG SUDAH DIBELI TIDAK ';
    cmds += ' DAPAT DITUKAR ATAU DIKEMBALIKAN </p>';
    cmds += newLine;
    /*cmds += ' <p style="text-align:center">JIKA MEMILIKI PERTANYAAN, SARAN,';
    cmds += '    ATAU KRITIK, HUBUNGI KAMI ';
    cmds += '     DI 081138911248 ATAU ';
    cmds += ' EMAIL: CS@SECRETGARDEN.CO.ID </p>';*/
    cmds += '<p style="text-align:center">TERIMA KASIH</p>';
    const container = document.getElementById('strukArea');
    container.innerHTML = cmds;

    

    const base64Data = btoa(cmds);
        
        // Untuk panggil APP Atau Popup RawBT
        const url2 = "rawbt:base64," + base64Data;
        
        // Redirect browser untuk membuka aplikasi RawBT
        window.location.href = url2;

    const imageBase64 = await this.convertToImage();
    const newWindow = window.open('', '', 'width=300,height=600');
    newWindow.document.write(cmds);
    newWindow.document.close();
   // newWindow.print();


    const base64 = imageBase64.split(',')[1];
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'image/png' });
    const url = URL.createObjectURL(blob);
    this.clearVariable();
  }

  
    makeLine(width) {
        return "-".repeat(width);
    }

    centerText(text, width) {
        if (text.length >= width) return text.substring(0, width);
        const padding = Math.floor((width - text.length) / 2);
        return " ".repeat(padding) + text;
    }

    padRow(leftStr, rightStr, width) {
      let combinedLen = leftStr.length + rightStr.length;
      
      if (combinedLen >= width) {
          let maxLeft = width - rightStr.length - 1;
          if (maxLeft < 1) maxLeft = 1;
          leftStr = leftStr.substring(0, maxLeft);
          combinedLen = leftStr.length + rightStr.length;
      }
      
      let spaces = width - combinedLen;
      if (spaces < 0) spaces = 0;
      return leftStr + " ".repeat(spaces) + rightStr;
  }

  
  updatePreview() {
    document.getElementById('previewArea').innerText = this.generateReceiptString();
  }
  
  generateReceiptString(){
    const width = 48;
    var dT = new Date(this.transDate+' '+this.transTime);
    let transactionDate = dT;
    let timezoneName = this.userProfile.counter_detail ? this.timezone[parseInt(this.userProfile.counter_detail.timezone)] : this.timezone[0];
    let convertTime = this.utilService.convertDateWithMoment(dT, timezoneName);
    let convertDate = this.utilService.convertDate(transactionDate);

    let monthName: any = this.monthList[(parseInt(convertDate.months)-1)];
    let transDate = convertDate.dates + '-' + monthName + '-' + convertDate.years;
    let transTime = convertTime.hours + ':' + convertTime.minutes + ':' + convertTime.seconds;

    let totalPromo: number = 0;
    let andaHemat: number = 0;
    let cmds = "";
    let newLine = "\n";
    
   let line ="-".repeat(width);
    cmds += this.centerText(String(this.companyName),width);
    cmds += newLine;
    if(this.receiptName!=''){
      cmds += this.centerText(String(this.receiptName),width);
      cmds += newLine;
    }
    cmds += this.centerText(String(this.userProfile.counter_detail.counter_name),width);
    cmds += newLine;
    if(this.companyNpwp!=''){
      cmds += this.getLabelHeaderReceipt("NPWP : " +String(this.companyNpwp));
      cmds += newLine;
    }
    cmds += this.centerText(String(this.companyAddress),width);
    cmds += newLine;
    if(this.userProfile.counter_detail.phone !== null && this.userProfile.counter_detail.phone !== '') {
      cmds += this.centerText(String(this.userProfile.counter_detail.phone),width);
    }
    cmds += newLine;
    cmds+=line;
    cmds += newLine;
    cmds += 'NO STRUK: ' + this.receiptNo;
    cmds += newLine;
    cmds += 'TANGGAL  : ' + transDate + ' ' + transTime;
    cmds += newLine;
    cmds += 'KASIR    : ' + this.cashierName.toUpperCase();
    cmds += newLine;
    if(this.stickerNumber!='' && this.stickerNumber !== null){
      cmds += 'NAMA BA  : ' + this.stickerNumber.toUpperCase();
      cmds += newLine;
    }
    cmds+=line;
    
    //Start List Barang Belanja
    cmds += newLine;
    let totalDiskonFreeItem = 0;
    for(let i = 0; i < this.productSales.length; i++) {
      let sales_transaction_detail_id: any = parseInt(this.productSales[i].sales_transaction_detail_id);
      if(this.productSales[i].typePromo !== 'FREE ITEM (ITEM)' && this.productSales[i].typePromo !== 'FREE ITEM (NOMINAL)') {
        let priceProduct: number = parseInt(this.productSales[i].price);
        let qtyBuy: number = parseInt(this.productSales[i].qty);
        let nettProduct: number = priceProduct * qtyBuy;
        let qtyFree: number = parseInt(this.productSales[i].qtyFree);
        let nettFree: number = priceProduct * qtyFree;
        if(this.productSales[i].qtyFree > 0) {
          if(qtyBuy>0){
            let lblPriceXQty: String = qtyBuy + ' x ' + this.formatRupiah(priceProduct.toString());
            let lblNettProduct: String = this.getLblNett(this.formatRupiah(nettProduct.toString()), lblPriceXQty.length);
            cmds+=this.productSales[i].initialName;
            cmds+=newLine;
            cmds+=lblPriceXQty.toString() + lblNettProduct.toString();
            cmds+= newLine;
          }
          /*let lblPriceXQtyFree: String = 'FREE ' + qtyFree + ' x ' + this.formatRupiah(priceProduct.toString());
          let lblNettFree: String = this.getLblNett('('+this.formatRupiah(nettFree.toString())+')', lblPriceXQtyFree.length);
          cmds+=this.productSales[i].initialName;
          cmds+= newLine;
          cmds+=lblPriceXQtyFree.toString() + lblNettFree.toString();
          cmds+= newLine;
          */
         totalDiskonFreeItem+=nettFree;
        } else {
          let lblPriceXQty: String = qtyBuy + ' x ' + this.formatRupiah(priceProduct.toString());
          let lblNettProduct: String = this.getLblNett(this.formatRupiah(nettProduct.toString()), lblPriceXQty.length);
          cmds+=this.productSales[i].initialName;
          cmds+= newLine;
          cmds+= lblPriceXQty.toString() + lblNettProduct.toString();
          cmds+= newLine;
        }
        
        if(this.salesDetailIsiHampers.length>0){
          let isi = this.salesDetailIsiHampers.filter(x=>x.sales_transaction_detail_id==sales_transaction_detail_id);
          if(isi.length>0){
            for(let ih=0;ih<isi.length;ih++){
              let qty_isi = parseInt(isi[ih].qty);
              let lblProductName: String = ' - '+isi[ih].product_name;
              let lblNettProduct: String = this.getLblNett('x'+this.formatRupiah(qty_isi.toString()), lblProductName.length);
              cmds+=lblProductName.toString()+ lblNettProduct.toString();
              cmds+= newLine;
            }
          }
        }
      }

      if(this.productSales[i].typePromo === 'FREE ITEM (ITEM)' || this.productSales[i].typePromo === 'FREE ITEM (NOMINAL)') {
        let price: number = parseInt(this.productSales[i].priceAfterPromo);
        let qty: number = parseInt(this.productSales[i].qtyFree);
        let nett: number = price * qty;
        /*let lblPriceAndQty: String = 'FREE ' + qty + ' x ' + this.formatRupiah(price.toString());
        let lblNett: String = this.getLblNett('('+this.formatRupiah(nett.toString())+')', lblPriceAndQty.length);
        cmds+= newLine;
        cmds+=this.productSales[i].initialName;
        cmds+= newLine;
        cmds+=lblPriceAndQty.toString() + lblNett.toString();
        cmds+= newLine;*/
        totalDiskonFreeItem+=nett;
      }
    }
    //End List Barang Belanja
    
    //Start Detail Promo Product
    for(let i = 0; i < this.productSales.length; i++) {
      if(this.productSales[i].typePromo !== 'FREE ITEM (ITEM)' && this.productSales[i].typePromo !== 'FREE ITEM (NOMINAL)') {
        if(this.productSales[i].typePromo === 'NOMINAL' || this.productSales[i].typePromo === 'PERSENTASE') {
          let countPromoDiff: number = (this.productSales[i].price * this.productSales[i].qty) - (this.productSales[i].priceAfterPromo * this.productSales[i].qty);
          totalPromo = totalPromo + countPromoDiff;
          
          /*let lblDiscount: String ='            DISKON :';
          let lblCountPromo: String = this.getLblNett('(' + this.formatRupiah(countPromoDiff.toString())+')', lblDiscount.length);
        
          cmds+=this.productSales[i].initialName;
          cmds+= newLine;
          cmds+=lblDiscount.toString()+ lblCountPromo;
          cmds += newLine;*/
        } else {
          if(this.productSales[i].valPromoNominal !== 0 || this.productSales[i].valPromoPercentage !== 0) {
            let countPromo: number = this.productSales[i].discNonRedeem;
            totalPromo = totalPromo + countPromo;
            /*let lblDiscount: String ='            DISKON :';
            let lblCountPromo: String = this.getLblNett('(' + this.formatRupiah(countPromo.toString())+')', lblDiscount.length);
            cmds += this.productSales[i].initialName;
            cmds+= newLine;
            cmds+=lblDiscount.toString()+ lblCountPromo;
            cmds+= newLine;*/
          }
        }
      }

      if(this.productSales[i].typePromo === 'FREE ITEM (ITEM)' || this.productSales[i].typePromo === 'FREE ITEM (NOMINAL)') {
       // totalPromo = totalPromo + (this.productSales[i].priceAfterPromo * this.productSales[i].qtyFree);
      }
        
      if(this.productSales[i].qtyFree>0 ) {
        andaHemat += (this.productSales[i].price * this.productSales[i].qtyFree);
      }
      if(Number(this.productSales[i].price)==1 && Number(this.productSales[i].qtyFree)==0){
       // andaHemat+= (Number(this.productSales[i].price) * Number(this.productSales[i].qty));
      }
    }
    andaHemat+=totalPromo
    //End Detail Promo Product

    //Start Voucher
    if(this.voucherValue !== 0) {
      /*cmds+= newLine;
      let lblVoucherPotongan: String =' VOUCHER POTONGAN  :';
      let lblCountVoucherPotongan: String = this.getLblNett( this.formatRupiah(this.voucherValue.toString()), lblVoucherPotongan.length);
      cmds+=lblVoucherPotongan.toString()+ lblCountVoucherPotongan.toString();*/
      andaHemat+=this.voucherValue;
    }
    //End Voucher 

    cmds+=line;
    
    cmds+= newLine;
    let lblAndaHemat: String   ='          TOTAL DISKON : ';
    let lblCountAndaHemat: String = this.getLblNett( this.formatRupiah(andaHemat.toString()), lblAndaHemat.length);
    cmds+=lblAndaHemat.toString()+ lblCountAndaHemat.toString();

    cmds+= newLine;
    
    let hargaJual =totalDiskonFreeItem+this.totalPaymentWithoutPromo;
    let lblPriceAndQty: String ='          HARGA JUAL   : ';
    let lblNett: String = this.getLblNett(this.formatRupiah(hargaJual.toString()), lblPriceAndQty.length);
    cmds+=lblPriceAndQty.toString()+ lblNett.toString();
    cmds+= newLine;     
    cmds+=line;
    cmds+= newLine;
    
    let totalItemPrice = this.totalPaymentWithoutPromo-totalPromo-this.voucherValue;
    let lblTotalItem: String = ('TOTAL ITEM ' + this.totalItem + ':').padStart(20, ' ');
    let lblCountTotalItem: String = this.getLblNett( this.formatRupiah(totalItemPrice.toString()), lblTotalItem.length);
    cmds+=lblTotalItem.toString()+ lblCountTotalItem.toString();
    cmds+= newLine;
    let lblTunai: String ='        TUNAI      :';
    let lblCountTotalTunai: String = this.getLblNett( this.formatRupiah(this.totalCustomerCash.toString()), lblTunai.length);
    cmds+=lblTunai.toString()+ lblCountTotalTunai.toString();
    
    //Start transfer
    if(this.customerTransfer !== 0) {
      cmds+= newLine;
      let lblTransfer: String ='        TRANSFER   :';
      let lblCountTotalTransfer: String = this.getLblNett( this.formatRupiah(this.customerTransfer.toString()), lblTransfer.length);
      cmds+=lblTransfer.toString()+ lblCountTotalTransfer.toString();
    }
    //Start Pembayaran Non Tunai
    if(this.customerCredit !== 0 && this.customerCredit !== null) {
      cmds+= newLine;
      let lblKredit: String ='        KREDIT     :';
      let lblCountTotalKredit: String = this.getLblNett( this.formatRupiah(this.customerCredit.toString()), lblKredit.length);
      cmds+=lblKredit.toString()+ lblCountTotalKredit.toString();
    }
    if(this.customerDebit !== 0 && this.customerDebit !== null) {
      cmds+= newLine;
      let lblDebit: String ='        DEBIT      :';
      let lblCountTotalDebit: String = this.getLblNett( this.formatRupiah(this.customerDebit.toString()), lblDebit.length);
      cmds+=lblDebit.toString()+ lblCountTotalDebit.toString();
    }
    //End Pembayaran Non Tunai
    //Start Penggunaan Point
    if(this.salesData.member_point!=0) {
      cmds+= newLine;
      let lblPoint: String ='        POINT RP   :';
      let lblCountTotalPoint: String = this.getLblNett( this.formatRupiah(this.salesData.member_point.toString()), lblPoint.length);
      cmds+=lblPoint.toString()+ lblCountTotalPoint.toString();

    }
    //End Penggunaan Point   
    //Start Payment Voucher
    if(this.paymentVoucher !== 0) {
      cmds+= newLine;
      let lblVoucherPembayaran: String =' VOUCHER PEMBAYARAN:';
      let lblCountVoucherPembayaran: String = this.getLblNett( this.formatRupiah(this.paymentVoucher.toString()), lblVoucherPembayaran.length);
      cmds+=lblVoucherPembayaran.toString()+ lblCountVoucherPembayaran.toString();
    }
    //End Payment Voucher
    
    cmds+= newLine;
    let lblKembali: String ='        KEMBALI    :';
    let lblCountKembali: String = this.getLblNett( this.formatRupiah(this.totalChange.toString()), lblKembali.length);
    cmds+=lblKembali.toString()+ lblCountKembali.toString();
    
    cmds+= newLine;
    let finalPayment = totalItemPrice;
    let lblDpp: String ='               DPP :';
    let dpp =Math.round((finalPayment/1.11)*(11/12));
    let lblCountDpp: String = this.getLblNett( this.formatRupiah(dpp.toString()), lblDpp.length);
    cmds+=lblDpp.toString()+ lblCountDpp.toString();
    
    cmds+= newLine;
    let lblPpn: String ='               PPN :';
    let ppn = Math.round(dpp*(12/100));
    let lblCountPpn: String = this.getLblNett( this.formatRupiah(ppn.toString()), lblPpn.length);
    cmds+=lblPpn.toString()+ lblCountPpn.toString();
    
    cmds+= newLine;
    cmds += line;
    if(this.paymentVoucherCode !== '' && this.paymentVoucherCode!=null) {    
      cmds+= newLine;
      cmds+='KODE VOUCHER PEMBAYARAN: ';
      cmds+= newLine;
      cmds+= this.paymentVoucherCode;
      cmds+= newLine;
      cmds += line;
    }
    if(this.voucherCode !== '' && this.voucherCode!=null) {
      cmds+= newLine;
      cmds+='KODE VOUCHER POTONGAN: ';
      cmds+= newLine;
      cmds+= this.voucherCode;
      cmds+= newLine;
      cmds += line;
    }

    if(this.memberPhone !== '') {
      if(this.memberName!='' && this.memberName!=null){
        cmds+= newLine;
        cmds+='NAMA MEMBER: '+ this.memberName;
      }
      cmds+= newLine;
      cmds+='PHONE: '+ this.memberPhone;
      if(this.showReferralCodeInStruck==true){
        cmds+= newLine;
        cmds+='REFERRAL CODE: '+ this.referralCode;
      }
      if(this.endPoint>0){
        cmds+= newLine;
        let lblEarlyPoint: String = 'POIN AWAL: ';
        let lblCountEarlyPoint: String = this.getLblNett( this.formatRupiah(this.earlyPoint.toString()), lblEarlyPoint.length);
        cmds+=lblEarlyPoint.toString()+ lblCountEarlyPoint.toString();
        
        cmds+= newLine;
        let lblInPoint: String = 'POIN DIDAPATKAN: ';
        let lblCountInPoint: String = this.getLblNett( this.formatRupiah(this.inPoint.toString()), lblInPoint.length);
        cmds+=lblInPoint.toString()+ lblCountInPoint.toString();

        cmds+= newLine;
        let lblOutPoint: String = 'POIN DIPAKAI: ';
        let lblCountOutPoint: String = this.getLblNett( this.formatRupiah(this.outPoint.toString()), lblOutPoint.length);
        cmds+=lblOutPoint.toString()+ lblCountOutPoint.toString();
        cmds+= newLine;
        let lblEndPoint: String = 'POIN AKHIR: ';
        let lblCountEndPoint: String = this.getLblNett( this.formatRupiah(this.endPoint.toString()), lblEndPoint.length);
        cmds+=lblEndPoint.toString()+ lblCountEndPoint.toString();
      }
      if(this.expiringPoin.length>0){
        let namaBulan = [
          'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
          'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'
        ];
        cmds+= newLine;
        cmds += 'POIN YANG AKAN EXPIRED';
        cmds+= newLine;
        cmds += 'TGL EXP           | JUMLAH POIN';
        for(let ep=0;ep<this.expiringPoin.length;ep++){
          let convertEpDate = this.utilService.convertDate(this.expiringPoin[ep].expired_date);
          let bulanEpIndex = Number(convertEpDate.months) -1 ;
          this.expiringPoin[ep].ep_date = convertEpDate.dates + ' ' + namaBulan[bulanEpIndex] + ' ' + convertEpDate.years;
          cmds+= newLine;
          let lblExpired: String = this.expiringPoin[ep].ep_date+' | ';
          let lblCountExpiredPoint: String = this.getLblNett( this.formatRupiah(this.expiringPoin[ep].point_remains.toString()), lblExpired.length);
          cmds+=lblExpired.toString()+ lblCountExpiredPoint.toString();
        }
      }
      cmds+= newLine;
      cmds += line;
      if(this.customerItem.length>0){
        cmds+= newLine;
        cmds +='BARANG DIBAWA PELANGGAN';
        for(let i=0;i<this.customerItem.length;i++){
          cmds+= newLine;
          cmds+=this.customerItem[i].item_name+' : '+ this.customerItem[i].item_qty;
        }
        cmds += newLine;
        cmds+= line;
      }
    }
    //End detail Member Point
    cmds += newLine;
    cmds += newLine;    
    cmds += this.centerText(String('BARANG YANG SUDAH DIBELI TIDAK'),width);
    cmds += newLine;
    cmds += this.centerText(String('DAPAT DITUKAR ATAU DIKEMBALIKAN'),width);
    cmds += newLine;
    cmds += newLine;
    cmds += this.centerText(String('TERIMA KASIH'),width);
    cmds += newLine;
    cmds += newLine;
    cmds += newLine;
    cmds += newLine;
    console.log(cmds)
    return cmds;
  }

  cetak(action:any){const textData = this.generateReceiptString();
    const previewArea = document.getElementById('previewAreaImin');
    if(action=='imin'){
      if (previewArea) {
        previewArea.innerText = this.generateReceiptString();
        previewArea.style.display = 'block';
      }
    }
    else{
      const base64Data = btoa(textData);
      const url = "rawbt:base64," + base64Data;
      this.clearVariable();
      window.location.href = url;
    }
  }
   generateReceiptDetail(){
    const width = 48;
    var dT = new Date(this.transDate+' '+this.transTime);
    let transactionDate = dT;
    let timezoneName = this.userProfile.counter_detail ? this.timezone[parseInt(this.userProfile.counter_detail.timezone)] : this.timezone[0];
    let convertTime = this.utilService.convertDateWithMoment(dT, timezoneName);
    let convertDate = this.utilService.convertDate(transactionDate);

    let monthName: any = this.monthList[(parseInt(convertDate.months)-1)];
    let transDate = convertDate.dates + '-' + monthName + '-' + convertDate.years;
    let transTime = convertTime.hours + ':' + convertTime.minutes + ':' + convertTime.seconds;

    let totalPromo: number = 0;
    let andaHemat: number = 0;
    let cmds = "";
    let newLine = "\n";
    
   let line ="-".repeat(width);
    cmds += this.centerText(String(this.receiptName),width);
    cmds += newLine;
    cmds += this.centerText(String(this.userProfile.counter_detail.counter_name),width);
    cmds += newLine;
    cmds += this.centerText(String(this.userProfile.counter_detail.first_address),width);
    cmds += newLine;
    cmds += this.centerText(String(this.userProfile.counter_detail.last_address),width);
    cmds += newLine;
    if(this.userProfile.counter_detail.phone !== null && this.userProfile.counter_detail.phone !== '') {
      cmds += this.centerText(String(this.userProfile.counter_detail.phone),width);
    }
    cmds += newLine;
    cmds+=line;
    cmds += newLine;
    cmds += 'NO STRUK: ' + this.receiptNo;
    cmds += newLine;
    cmds += 'TANGGAL  : ' + transDate + ' ' + transTime;
    cmds += newLine;
    cmds += 'KASIR    : ' + this.cashierName.toUpperCase();
    cmds += newLine;
    if(this.stickerNumber!='' && this.stickerNumber !== null){
      cmds += 'NAMA BA    : ' + this.stickerNumber.toUpperCase();
      cmds += newLine;
    }
    cmds+=line;
    
    //Start List Barang Belanja
    cmds += newLine;
    for(let i = 0; i < this.productSales.length; i++) {
      let sales_transaction_detail_id: any = parseInt(this.productSales[i].sales_transaction_detail_id);
      if(this.productSales[i].typePromo !== 'FREE ITEM (ITEM)' && this.productSales[i].typePromo !== 'FREE ITEM (NOMINAL)') {
        let priceProduct: number = parseInt(this.productSales[i].price);
        let qtyBuy: number = parseInt(this.productSales[i].qty);
        let nettProduct: number = priceProduct * qtyBuy;
        let qtyFree: number = parseInt(this.productSales[i].qtyFree);
        let nettFree: number = priceProduct * qtyFree;
        if(this.productSales[i].qtyFree > 0) {
          if(qtyBuy>0){
            let lblPriceXQty: String = qtyBuy + ' x ' + this.formatRupiah(priceProduct.toString());
            let lblNettProduct: String = this.getLblNett(this.formatRupiah(nettProduct.toString()), lblPriceXQty.length);
            cmds+=this.productSales[i].initialName;
            cmds+=newLine;
            cmds+=lblPriceXQty.toString() + lblNettProduct.toString();
            cmds+= newLine;
          }
          let lblPriceXQtyFree: String = 'FREE ' + qtyFree + ' x ' + this.formatRupiah(priceProduct.toString());
          let lblNettFree: String = this.getLblNett('('+this.formatRupiah(nettFree.toString())+')', lblPriceXQtyFree.length);
          cmds+=this.productSales[i].initialName;
          cmds+= newLine;
          cmds+=lblPriceXQtyFree.toString() + lblNettFree.toString();
          cmds+= newLine;
        } else {
          let lblPriceXQty: String = qtyBuy + ' x ' + this.formatRupiah(priceProduct.toString());
          let lblNettProduct: String = this.getLblNett(this.formatRupiah(nettProduct.toString()), lblPriceXQty.length);
          cmds+=this.productSales[i].initialName;
          cmds+= newLine;
          cmds+= lblPriceXQty.toString() + lblNettProduct.toString();
          cmds+= newLine;
        }
        
        if(this.salesDetailIsiHampers.length>0){
          let isi = this.salesDetailIsiHampers.filter(x=>x.sales_transaction_detail_id==sales_transaction_detail_id);
          if(isi.length>0){
            for(let ih=0;ih<isi.length;ih++){
              let qty_isi = parseInt(isi[ih].qty);
              let lblProductName: String = ' - '+isi[ih].product_name;
              let lblNettProduct: String = this.getLblNett('x'+this.formatRupiah(qty_isi.toString()), lblProductName.length);
              cmds+=lblProductName.toString()+ lblNettProduct.toString();
              cmds+= newLine;
            }
          }
        }
      }

      if(this.productSales[i].typePromo === 'FREE ITEM (ITEM)' || this.productSales[i].typePromo === 'FREE ITEM (NOMINAL)') {
        let price: number = parseInt(this.productSales[i].priceAfterPromo);
        let qty: number = parseInt(this.productSales[i].qtyFree);
        let nett: number = price * qty;
        let lblPriceAndQty: String = 'FREE ' + qty + ' x ' + this.formatRupiah(price.toString());
        let lblNett: String = this.getLblNett('('+this.formatRupiah(nett.toString())+')', lblPriceAndQty.length);
        cmds+= newLine;
        cmds+=this.productSales[i].initialName;
        cmds+= newLine;
        cmds+=lblPriceAndQty.toString() + lblNett.toString();
        cmds+= newLine;
      }
    }
    //End List Barang Belanja
    
    cmds+=line;
    cmds+= newLine;
    let lblPriceAndQty: String ='            HARGA JUAL : ';
    let lblNett: String = this.getLblNett(this.formatRupiah(this.totalPaymentWithoutPromo.toString()), lblPriceAndQty.length);
    cmds+=lblPriceAndQty.toString()+ lblNett.toString();
    cmds+= newLine;

    
    //Start Detail Promo Product
    for(let i = 0; i < this.productSales.length; i++) {
      if(this.productSales[i].typePromo !== 'FREE ITEM (ITEM)' && this.productSales[i].typePromo !== 'FREE ITEM (NOMINAL)') {
        if(this.productSales[i].typePromo === 'NOMINAL' || this.productSales[i].typePromo === 'PERSENTASE') {
          let countPromoDiff: number = (this.productSales[i].price * this.productSales[i].qty) - (this.productSales[i].priceAfterPromo * this.productSales[i].qty);
          totalPromo = totalPromo + countPromoDiff;
          
          let lblDiscount: String ='            DISKON :';
          let lblCountPromo: String = this.getLblNett('(' + this.formatRupiah(countPromoDiff.toString())+')', lblDiscount.length);
        
          cmds+=this.productSales[i].initialName;
          cmds+= newLine;
          cmds+=lblDiscount.toString()+ lblCountPromo;
          cmds += newLine;
        } else {
          if(this.productSales[i].valPromoNominal !== 0 || this.productSales[i].valPromoPercentage !== 0) {
            let countPromo: number = this.productSales[i].discNonRedeem;
            totalPromo = totalPromo + countPromo;
            let lblDiscount: String ='            DISKON :';
            let lblCountPromo: String = this.getLblNett('(' + this.formatRupiah(countPromo.toString())+')', lblDiscount.length);
            cmds += this.productSales[i].initialName;
            cmds+= newLine;
            cmds+=lblDiscount.toString()+ lblCountPromo;
            cmds+= newLine;
          }
        }
      }

      if(this.productSales[i].typePromo === 'FREE ITEM (ITEM)' || this.productSales[i].typePromo === 'FREE ITEM (NOMINAL)') {
       // totalPromo = totalPromo + (this.productSales[i].priceAfterPromo * this.productSales[i].qtyFree);
      }
        
      if(this.productSales[i].qtyFree>0 ) {
        andaHemat += (this.productSales[i].price * this.productSales[i].qtyFree);
      }
    }
    andaHemat+=totalPromo
    //End Detail Promo Product
        
    cmds+=line;
    cmds+= newLine;
    
    let totalItemPrice = this.totalPaymentWithoutPromo-totalPromo;
    let lblTotalItem: String ='        TOTAL ITEM ' + this.totalItem +':';
    let lblCountTotalItem: String = this.getLblNett( this.formatRupiah(totalItemPrice.toString()), lblTotalItem.length);
    cmds+=lblTotalItem.toString()+ lblCountTotalItem.toString();
    cmds+= newLine;
    let lblTunai: String ='        TUNAI      :';
    let lblCountTotalTunai: String = this.getLblNett( this.formatRupiah(this.totalCustomerCash.toString()), lblTunai.length);
    cmds+=lblTunai.toString()+ lblCountTotalTunai.toString();
    
    //Start transfer
    if(this.customerTransfer !== 0) {
      cmds+= newLine;
      let lblTransfer: String ='        TRANSFER   :';
      let lblCountTotalTransfer: String = this.getLblNett( this.formatRupiah(this.customerTransfer.toString()), lblTransfer.length);
      cmds+=lblTransfer.toString()+ lblCountTotalTransfer.toString();
    }
    //Start Pembayaran Non Tunai
    if(this.customerCredit !== 0 && this.customerCredit !== null) {
      cmds+= newLine;
      let lblKredit: String ='        KREDIT     :';
      let lblCountTotalKredit: String = this.getLblNett( this.formatRupiah(this.customerCredit.toString()), lblKredit.length);
      cmds+=lblKredit.toString()+ lblCountTotalKredit.toString();
    }
    if(this.customerDebit !== 0 && this.customerDebit !== null) {
      cmds+= newLine;
      let lblDebit: String ='        DEBIT      :';
      let lblCountTotalDebit: String = this.getLblNett( this.formatRupiah(this.customerDebit.toString()), lblDebit.length);
      cmds+=lblDebit.toString()+ lblCountTotalDebit.toString();
    }
    //End Pembayaran Non Tunai
    //Start Penggunaan Point
    if(this.salesData.member_point!=0) {
      cmds+= newLine;
      let lblPoint: String ='        POINT RP   :';
      let lblCountTotalPoint: String = this.getLblNett( this.formatRupiah(this.salesData.member_point.toString()), lblPoint.length);
      cmds+=lblPoint.toString()+ lblCountTotalPoint.toString();

    }
    //End Penggunaan Point

    //Start Voucher
    if(this.voucherValue !== 0) {
      cmds+= newLine;
      let lblVoucherPotongan: String =' VOUCHER POTONGAN  :';
      let lblCountVoucherPotongan: String = this.getLblNett( this.formatRupiah(this.voucherValue.toString()), lblVoucherPotongan.length);
      cmds+=lblVoucherPotongan.toString()+ lblCountVoucherPotongan.toString();
    }
    //End Voucher    
    //Start Payment Voucher
    if(this.paymentVoucher !== 0) {
      cmds+= newLine;
      let lblVoucherPembayaran: String =' VOUCHER PEMBAYARAN:';
      let lblCountVoucherPembayaran: String = this.getLblNett( this.formatRupiah(this.paymentVoucher.toString()), lblVoucherPembayaran.length);
      cmds+=lblVoucherPembayaran.toString()+ lblCountVoucherPembayaran.toString();
    }
    //End Payment Voucher
    
    cmds+= newLine;
    let lblKembali: String ='        KEMBALI    :';
    let lblCountKembali: String = this.getLblNett( this.formatRupiah(this.totalChange.toString()), lblKembali.length);
    cmds+=lblKembali.toString()+ lblCountKembali.toString();
    
    cmds+= newLine;
    let lblAndaHemat: String ='        ANDA HEMAT :';
    let lblCountAndaHemat: String = this.getLblNett( this.formatRupiah(andaHemat.toString()), lblAndaHemat.length);
    cmds+=lblAndaHemat.toString()+ lblCountAndaHemat.toString();
    
    cmds+= newLine;
    cmds += line;
    if(this.paymentVoucherCode !== '' && this.paymentVoucherCode!=null) {    
      cmds+= newLine;
      cmds+='KODE VOUCHER PEMBAYARAN: ';
      cmds+= newLine;
      cmds+= this.paymentVoucherCode;
      cmds+= newLine;
      cmds += line;
    }
    if(this.voucherCode !== '' && this.voucherCode!=null) {
      cmds+= newLine;
      cmds+='KODE VOUCHER POTONGAN: ';
      cmds+= newLine;
      cmds+= this.voucherCode;
      cmds+= newLine;
      cmds += line;
    }

    if(this.memberPhone !== '') {
      if(this.memberName!='' && this.memberName!=null){
        cmds+= newLine;
        cmds+='NAMA MEMBER: '+ this.memberName;
      }
      cmds+= newLine;
      cmds+='PHONE: '+ this.memberPhone;
      if(this.showReferralCodeInStruck==true){
        cmds+= newLine;
        cmds+='REFERRAL CODE: '+ this.referralCode;
      }
      if(this.endPoint>0){
        cmds+= newLine;
        let lblEarlyPoint: String = 'POIN AWAL: ';
        let lblCountEarlyPoint: String = this.getLblNett( this.formatRupiah(this.earlyPoint.toString()), lblEarlyPoint.length);
        cmds+=lblEarlyPoint.toString()+ lblCountEarlyPoint.toString();
        
        cmds+= newLine;
        let lblInPoint: String = 'POIN DIDAPATKAN: ';
        let lblCountInPoint: String = this.getLblNett( this.formatRupiah(this.inPoint.toString()), lblInPoint.length);
        cmds+=lblInPoint.toString()+ lblCountInPoint.toString();

        cmds+= newLine;
        let lblOutPoint: String = 'POIN DIPAKAI: ';
        let lblCountOutPoint: String = this.getLblNett( this.formatRupiah(this.outPoint.toString()), lblOutPoint.length);
        cmds+=lblOutPoint.toString()+ lblCountOutPoint.toString();
        cmds+= newLine;
        let lblEndPoint: String = 'POIN AKHIR: ';
        let lblCountEndPoint: String = this.getLblNett( this.formatRupiah(this.endPoint.toString()), lblEndPoint.length);
        cmds+=lblEndPoint.toString()+ lblCountEndPoint.toString();
      }
      if(this.expiringPoin.length>0){
        let namaBulan = [
          'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
          'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'
        ];
        cmds+= newLine;
        cmds += 'POIN YANG AKAN EXPIRED';
        cmds+= newLine;
        cmds += 'TGL EXP           | JUMLAH POIN';
        for(let ep=0;ep<this.expiringPoin.length;ep++){
          let convertEpDate = this.utilService.convertDate(this.expiringPoin[ep].expired_date);
          let bulanEpIndex = Number(convertEpDate.months) -1 ;
          this.expiringPoin[ep].ep_date = convertEpDate.dates + ' ' + namaBulan[bulanEpIndex] + ' ' + convertEpDate.years;
          cmds+= newLine;
          let lblExpired: String = this.expiringPoin[ep].ep_date+' | ';
          let lblCountExpiredPoint: String = this.getLblNett( this.formatRupiah(this.expiringPoin[ep].point_remains.toString()), lblExpired.length);
          cmds+=lblExpired.toString()+ lblCountExpiredPoint.toString();
        }
      }
      cmds+= newLine;
      cmds += line;
      if(this.customerItem.length>0){
        cmds+= newLine;
        cmds +='BARANG DIBAWA PELANGGAN';
        for(let i=0;i<this.customerItem.length;i++){
          cmds+= newLine;
          cmds+=this.customerItem[i].item_name+' : '+ this.customerItem[i].item_qty;
        }
        cmds += newLine;
        cmds+= line;
      }
    }
    //End detail Member Point
    cmds += newLine;
    cmds += newLine;    
    cmds += this.centerText(String('BARANG YANG SUDAH DIBELI TIDAK'),width);
    cmds += newLine;
    cmds += this.centerText(String('DAPAT DITUKAR ATAU DIKEMBALIKAN'),width);
    cmds += newLine;
   /* cmds += newLine;
    cmds += this.centerText(String('JIKA MEMILIKI PERTANYAAN, SARAN,'),width);
    cmds += newLine;
    cmds += this.centerText(String('ATAU KRITIK, HUBUNGI KAMI'),width);
    cmds += newLine;
    cmds += this.centerText(String(' DI 081138911248 ATAU'),width);
    cmds += newLine;
    cmds += this.centerText(String(' EMAIL: CS@SECRETGARDEN.CO.ID'),width);
    cmds += newLine;*/
    cmds += newLine;
    cmds += this.centerText(String('TERIMA KASIH'),width);
    cmds += newLine;
    cmds += newLine;
    cmds += newLine;
    cmds += newLine;
    return cmds;
  }
}